export type TeamRevealPlayer = {
	id: string;
	name: string;
	team: string;
	pos: string;
	price: number;
	mpg: number;
	per: number;
	vorp: number;
	pts: number;
	trb: number;
	ast: number;
	off: number;
	def: number;
	space: number;
	create: number;
	usage: number;
	reb: number;
};

export const TEAM_REVEAL_PLAYERS: TeamRevealPlayer[] = [
	{
		id: "johnsja05",
		name: "Jalen Johnson",
		team: "ATL",
		pos: "F",
		price: 10,
		mpg: 35.7,
		per: 17.3,
		vorp: 1.2,
		pts: 18.9,
		trb: 10,
		ast: 5,
		off: 96,
		def: 80,
		space: 67,
		create: 99,
		usage: 73,
		reb: 99,
	},
	{
		id: "daniedy01",
		name: "Dyson Daniels",
		team: "ATL",
		pos: "G",
		price: 10,
		mpg: 33.8,
		per: 15.6,
		vorp: 2.3,
		pts: 14.1,
		trb: 5.9,
		ast: 4.4,
		off: 84,
		def: 87,
		space: 60,
		create: 95,
		usage: 64,
		reb: 80,
	},
	{
		id: "wiggiaa01",
		name: "Aaron Wiggins",
		team: "ATL",
		pos: "SG",
		price: 8,
		mpg: 22.9,
		per: 16.1,
		vorp: 1.4,
		pts: 12,
		trb: 3.9,
		ast: 1.8,
		off: 97,
		def: 71,
		space: 81,
		create: 83,
		usage: 69,
		reb: 74,
	},
	{
		id: "mccolcj01",
		name: "CJ McCollum",
		team: "ATL",
		pos: "G",
		price: 8,
		mpg: 32.7,
		per: 15.8,
		vorp: 0.3,
		pts: 21.1,
		trb: 3.8,
		ast: 4.1,
		off: 99,
		def: 56,
		space: 94,
		create: 96,
		usage: 83,
		reb: 69,
	},
	{
		id: "okongon01",
		name: "Onyeka Okongwu",
		team: "ATL",
		pos: "C",
		price: 6,
		mpg: 27.9,
		per: 19,
		vorp: 1.7,
		pts: 13.4,
		trb: 8.9,
		ast: 2.3,
		off: 92,
		def: 74,
		space: 68,
		create: 83,
		usage: 62,
		reb: 97,
	},
	{
		id: "kuminjo01",
		name: "Jonathan Kuminga",
		team: "ATL",
		pos: "F",
		price: 6,
		mpg: 24.3,
		per: 15.7,
		vorp: 0.4,
		pts: 15.3,
		trb: 4.6,
		ast: 2.2,
		off: 85,
		def: 70,
		space: 65,
		create: 90,
		usage: 84,
		reb: 85,
	},
	{
		id: "hieldbu01",
		name: "Buddy Hield",
		team: "ATL",
		pos: "GF",
		price: 4,
		mpg: 22.7,
		per: 12.3,
		vorp: 0.5,
		pts: 11.1,
		trb: 3.2,
		ast: 1.6,
		off: 89,
		def: 66,
		space: 96,
		create: 81,
		usage: 69,
		reb: 69,
	},
	{
		id: "alexani01",
		name: "Nickeil Alexander-Walker",
		team: "ATL",
		pos: "SG",
		price: 4,
		mpg: 25.3,
		per: 11.6,
		vorp: 0.8,
		pts: 9.4,
		trb: 3.2,
		ast: 2.7,
		off: 86,
		def: 70,
		space: 86,
		create: 85,
		usage: 59,
		reb: 67,
	},
	{
		id: "kispeco01",
		name: "Corey Kispert",
		team: "ATL",
		pos: "SF",
		price: 2,
		mpg: 26.3,
		per: 11,
		vorp: -0.7,
		pts: 11.6,
		trb: 3,
		ast: 1.7,
		off: 84,
		def: 56,
		space: 92,
		create: 81,
		usage: 63,
		reb: 68,
	},
	{
		id: "risacza01",
		name: "Zaccharie Risacher",
		team: "ATL",
		pos: "SF",
		price: 2,
		mpg: 24.6,
		per: 12.2,
		vorp: -0.7,
		pts: 12.6,
		trb: 3.6,
		ast: 1.2,
		off: 80,
		def: 63,
		space: 77,
		create: 78,
		usage: 70,
		reb: 71,
	},
	{
		id: "portemi01",
		name: "Michael Porter Jr.",
		team: "BKN",
		pos: "SF",
		price: 10,
		mpg: 33.7,
		per: 16.2,
		vorp: 1.2,
		pts: 18.2,
		trb: 7,
		ast: 2.1,
		off: 99,
		def: 63,
		space: 95,
		create: 84,
		usage: 68,
		reb: 91,
	},
	{
		id: "randlju01",
		name: "Julius Randle",
		team: "BKN",
		pos: "FC",
		price: 10,
		mpg: 32.3,
		per: 17.5,
		vorp: 1.8,
		pts: 18.7,
		trb: 7.1,
		ast: 4.7,
		off: 95,
		def: 68,
		space: 68,
		create: 99,
		usage: 79,
		reb: 91,
	},
	{
		id: "wagnemo01",
		name: "Moritz Wagner",
		team: "BKN",
		pos: "C",
		price: 8,
		mpg: 18.8,
		per: 22.3,
		vorp: 0.9,
		pts: 12.9,
		trb: 4.9,
		ast: 1.4,
		off: 91,
		def: 74,
		space: 63,
		create: 82,
		usage: 83,
		reb: 87,
	},
	{
		id: "sharpda01",
		name: "Day'Ron Sharpe",
		team: "BKN",
		pos: "FC",
		price: 8,
		mpg: 18.2,
		per: 19.7,
		vorp: 0.7,
		pts: 7.9,
		trb: 6.6,
		ast: 1.8,
		off: 78,
		def: 80,
		space: 49,
		create: 82,
		usage: 68,
		reb: 97,
	},
	{
		id: "willizi02",
		name: "Ziaire Williams",
		team: "BKN",
		pos: "SF",
		price: 6,
		mpg: 24.5,
		per: 11.9,
		vorp: -0.1,
		pts: 10,
		trb: 4.6,
		ast: 1.3,
		off: 77,
		def: 70,
		space: 79,
		create: 78,
		usage: 64,
		reb: 76,
	},
	{
		id: "elliske01",
		name: "Keon Ellis",
		team: "BKN",
		pos: "SG",
		price: 6,
		mpg: 24.4,
		per: 13.5,
		vorp: 1.9,
		pts: 8.3,
		trb: 2.7,
		ast: 1.5,
		off: 83,
		def: 80,
		space: 78,
		create: 76,
		usage: 52,
		reb: 65,
	},
	{
		id: "demineg01",
		name: "Egor Dеmin",
		team: "BKN",
		pos: "PG",
		price: 4,
		mpg: 25.2,
		per: 11.3,
		vorp: 0.1,
		pts: 10.3,
		trb: 3.2,
		ast: 3.3,
		off: 79,
		def: 63,
		space: 85,
		create: 86,
		usage: 65,
		reb: 70,
	},
	{
		id: "minotjo01",
		name: "Josh Minott",
		team: "BKN",
		pos: "F",
		price: 4,
		mpg: 6,
		per: 15.5,
		vorp: 0.3,
		pts: 2.6,
		trb: 1,
		ast: 0.4,
		off: 76,
		def: 81,
		space: 65,
		create: 71,
		usage: 62,
		reb: 69,
	},
	{
		id: "agbajoc01",
		name: "Ochai Agbaji",
		team: "BKN",
		pos: "SG",
		price: 2,
		mpg: 27.2,
		per: 12,
		vorp: 0.5,
		pts: 10.4,
		trb: 3.8,
		ast: 1.5,
		off: 77,
		def: 67,
		space: 72,
		create: 74,
		usage: 56,
		reb: 72,
	},
	{
		id: "mannte01",
		name: "Terance Mann",
		team: "BKN",
		pos: "GF",
		price: 2,
		mpg: 19.8,
		per: 10.5,
		vorp: 0.1,
		pts: 6,
		trb: 2.9,
		ast: 1.6,
		off: 70,
		def: 71,
		space: 67,
		create: 78,
		usage: 55,
		reb: 72,
	},
	{
		id: "tatumja01",
		name: "Jayson Tatum",
		team: "BOS",
		pos: "F",
		price: 10,
		mpg: 36.4,
		per: 21.7,
		vorp: 4.8,
		pts: 26.8,
		trb: 8.7,
		ast: 6,
		off: 99,
		def: 76,
		space: 95,
		create: 99,
		usage: 92,
		reb: 98,
	},
	{
		id: "georgpa01",
		name: "Paul George",
		team: "BOS",
		pos: "GF",
		price: 10,
		mpg: 32.5,
		per: 14.5,
		vorp: 0.5,
		pts: 16.2,
		trb: 5.3,
		ast: 4.3,
		off: 92,
		def: 73,
		space: 83,
		create: 96,
		usage: 76,
		reb: 79,
	},
	{
		id: "whitede01",
		name: "Derrick White",
		team: "BOS",
		pos: "G",
		price: 8,
		mpg: 33.9,
		per: 16.6,
		vorp: 3.6,
		pts: 16.4,
		trb: 4.5,
		ast: 4.8,
		off: 99,
		def: 75,
		space: 99,
		create: 99,
		usage: 68,
		reb: 75,
	},
	{
		id: "pritcpa01",
		name: "Payton Pritchard",
		team: "BOS",
		pos: "G",
		price: 8,
		mpg: 28.4,
		per: 17.6,
		vorp: 3.2,
		pts: 14.3,
		trb: 3.8,
		ast: 3.5,
		off: 99,
		def: 67,
		space: 99,
		create: 91,
		usage: 66,
		reb: 76,
	},
	{
		id: "hausesa01",
		name: "Sam Hauser",
		team: "BOS",
		pos: "F",
		price: 6,
		mpg: 21.7,
		per: 12.8,
		vorp: 1.1,
		pts: 8.5,
		trb: 3.2,
		ast: 0.9,
		off: 95,
		def: 68,
		space: 97,
		create: 74,
		usage: 56,
		reb: 73,
	},
	{
		id: "bantoda01",
		name: "Dalano Banton",
		team: "BOS",
		pos: "PG",
		price: 6,
		mpg: 16.7,
		per: 12.9,
		vorp: 0.3,
		pts: 8.3,
		trb: 2,
		ast: 2.4,
		off: 80,
		def: 68,
		space: 69,
		create: 88,
		usage: 77,
		reb: 66,
	},
	{
		id: "quetane01",
		name: "Neemias Queta",
		team: "BOS",
		pos: "C",
		price: 4,
		mpg: 13.9,
		per: 16.3,
		vorp: 0.3,
		pts: 5,
		trb: 3.8,
		ast: 0.7,
		off: 73,
		def: 77,
		space: 39,
		create: 72,
		usage: 54,
		reb: 85,
	},
	{
		id: "garzalu01",
		name: "Luka Garza",
		team: "BOS",
		pos: "C",
		price: 4,
		mpg: 5.6,
		per: 18.8,
		vorp: 0,
		pts: 3.5,
		trb: 1.4,
		ast: 0.3,
		off: 76,
		def: 62,
		space: 60,
		create: 78,
		usage: 81,
		reb: 74,
	},
	{
		id: "conlemi01",
		name: "Mike Conley",
		team: "BOS",
		pos: "PG",
		price: 2,
		mpg: 24.7,
		per: 13.3,
		vorp: 1.4,
		pts: 8.2,
		trb: 2.6,
		ast: 4.5,
		off: 79,
		def: 72,
		space: 76,
		create: 92,
		usage: 56,
		reb: 66,
	},
	{
		id: "robinmi01",
		name: "Mitchell Robinson",
		team: "BOS",
		pos: "C",
		price: 2,
		mpg: 17.1,
		per: 20.4,
		vorp: 0.4,
		pts: 5.1,
		trb: 5.9,
		ast: 0.8,
		off: 75,
		def: 84,
		space: 35,
		create: 68,
		usage: 49,
		reb: 94,
	},
	{
		id: "reidna01",
		name: "Naz Reid",
		team: "CHA",
		pos: "FC",
		price: 10,
		mpg: 27.5,
		per: 15.8,
		vorp: 2,
		pts: 14.2,
		trb: 6,
		ast: 2.3,
		off: 95,
		def: 77,
		space: 88,
		create: 83,
		usage: 71,
		reb: 86,
	},
	{
		id: "millebr02",
		name: "Brandon Miller",
		team: "CHA",
		pos: "SF",
		price: 10,
		mpg: 34.2,
		per: 14,
		vorp: 0.4,
		pts: 21,
		trb: 4.9,
		ast: 3.6,
		off: 95,
		def: 65,
		space: 99,
		create: 96,
		usage: 85,
		reb: 76,
	},
	{
		id: "knuepko01",
		name: "Kon Knueppel",
		team: "CHA",
		pos: "SF",
		price: 8,
		mpg: 31.5,
		per: 17.1,
		vorp: 3.1,
		pts: 18.5,
		trb: 5.3,
		ast: 3.4,
		off: 99,
		def: 65,
		space: 99,
		create: 91,
		usage: 73,
		reb: 82,
	},
	{
		id: "manntr01",
		name: "Tre Mann",
		team: "CHA",
		pos: "PG",
		price: 8,
		mpg: 24.5,
		per: 13.3,
		vorp: 0,
		pts: 14.1,
		trb: 2.9,
		ast: 3,
		off: 89,
		def: 60,
		space: 78,
		create: 93,
		usage: 81,
		reb: 72,
	},
	{
		id: "allengr01",
		name: "Grayson Allen",
		team: "CHA",
		pos: "SG",
		price: 6,
		mpg: 24.1,
		per: 13.7,
		vorp: 0.7,
		pts: 10.6,
		trb: 3,
		ast: 2.1,
		off: 95,
		def: 64,
		space: 91,
		create: 84,
		usage: 63,
		reb: 68,
	},
	{
		id: "onealro01",
		name: "Royce O'Neale",
		team: "CHA",
		pos: "SF",
		price: 6,
		mpg: 24.5,
		per: 12.6,
		vorp: 1,
		pts: 9.1,
		trb: 4.7,
		ast: 2.2,
		off: 90,
		def: 70,
		space: 92,
		create: 81,
		usage: 58,
		reb: 77,
	},
	{
		id: "whiteco01",
		name: "Coby White",
		team: "CHA",
		pos: "G",
		price: 4,
		mpg: 33.1,
		per: 15.5,
		vorp: 0.7,
		pts: 20.4,
		trb: 3.7,
		ast: 4.5,
		off: 89,
		def: 59,
		space: 96,
		create: 99,
		usage: 77,
		reb: 74,
	},
	{
		id: "connapa01",
		name: "Pat Connaughton",
		team: "CHA",
		pos: "GF",
		price: 4,
		mpg: 14.7,
		per: 12.1,
		vorp: 0,
		pts: 5.3,
		trb: 2.7,
		ast: 1.7,
		off: 77,
		def: 62,
		space: 68,
		create: 77,
		usage: 59,
		reb: 73,
	},
	{
		id: "finnedo01",
		name: "Dorian Finney-Smith",
		team: "CHA",
		pos: "F",
		price: 2,
		mpg: 29,
		per: 12.2,
		vorp: 0.3,
		pts: 10.4,
		trb: 4.6,
		ast: 1.6,
		off: 79,
		def: 69,
		space: 77,
		create: 74,
		usage: 56,
		reb: 74,
	},
	{
		id: "willigr01",
		name: "Grant Williams",
		team: "CHA",
		pos: "PF",
		price: 2,
		mpg: 29.9,
		per: 11.5,
		vorp: 0.1,
		pts: 10.4,
		trb: 5.1,
		ast: 2.3,
		off: 70,
		def: 69,
		space: 80,
		create: 79,
		usage: 57,
		reb: 78,
	},
	{
		id: "giddejo01",
		name: "Josh Giddey",
		team: "CHI",
		pos: "GF",
		price: 10,
		mpg: 30.2,
		per: 18.1,
		vorp: 2.7,
		pts: 14.6,
		trb: 8.1,
		ast: 7.2,
		off: 99,
		def: 77,
		space: 71,
		create: 99,
		usage: 72,
		reb: 98,
	},
	{
		id: "powelno01",
		name: "Norman Powell",
		team: "CHI",
		pos: "GF",
		price: 10,
		mpg: 32.6,
		per: 17.5,
		vorp: 1.8,
		pts: 21.8,
		trb: 3.2,
		ast: 2.1,
		off: 99,
		def: 67,
		space: 90,
		create: 88,
		usage: 81,
		reb: 69,
	},
	{
		id: "smithja04",
		name: "Jalen Smith",
		team: "CHI",
		pos: "FC",
		price: 8,
		mpg: 15,
		per: 18.7,
		vorp: 0.7,
		pts: 8.2,
		trb: 5.6,
		ast: 1,
		off: 90,
		def: 67,
		space: 74,
		create: 76,
		usage: 70,
		reb: 89,
	},
	{
		id: "dilliro01",
		name: "Rob Dillingham",
		team: "CHI",
		pos: "PG",
		price: 8,
		mpg: 10.5,
		per: 10.2,
		vorp: -0.3,
		pts: 4.5,
		trb: 1,
		ast: 2,
		off: 75,
		def: 62,
		space: 62,
		create: 85,
		usage: 74,
		reb: 63,
	},
	{
		id: "colliza01",
		name: "Zach Collins",
		team: "CHI",
		pos: "FC",
		price: 6,
		mpg: 11.8,
		per: 14.4,
		vorp: 0.2,
		pts: 4.6,
		trb: 2.8,
		ast: 1.4,
		off: 76,
		def: 75,
		space: 61,
		create: 79,
		usage: 62,
		reb: 76,
	},
	{
		id: "buzelma01",
		name: "Matas Buzelis",
		team: "CHI",
		pos: "F",
		price: 6,
		mpg: 18.9,
		per: 12.5,
		vorp: -0.2,
		pts: 8.6,
		trb: 3.5,
		ast: 1,
		off: 77,
		def: 67,
		space: 73,
		create: 78,
		usage: 65,
		reb: 74,
	},
	{
		id: "claxtni01",
		name: "Nic Claxton",
		team: "CHI",
		pos: "C",
		price: 4,
		mpg: 26.9,
		per: 16.5,
		vorp: 1.1,
		pts: 10.3,
		trb: 7.4,
		ast: 2.2,
		off: 75,
		def: 78,
		space: 39,
		create: 80,
		usage: 61,
		reb: 91,
	},
	{
		id: "jonestr01",
		name: "Tre Jones",
		team: "CHI",
		pos: "PG",
		price: 4,
		mpg: 16.1,
		per: 13.8,
		vorp: 0.2,
		pts: 4.4,
		trb: 2.1,
		ast: 3.7,
		off: 75,
		def: 71,
		space: 56,
		create: 90,
		usage: 51,
		reb: 67,
	},
	{
		id: "yabusgu01",
		name: "Guerschon Yabusele",
		team: "CHI",
		pos: "FC",
		price: 2,
		mpg: 27.1,
		per: 14.7,
		vorp: 0.5,
		pts: 11,
		trb: 5.6,
		ast: 2.1,
		off: 83,
		def: 64,
		space: 72,
		create: 78,
		usage: 60,
		reb: 82,
	},
	{
		id: "willipa01",
		name: "Patrick Williams",
		team: "CHI",
		pos: "PF",
		price: 2,
		mpg: 25,
		per: 9,
		vorp: -0.7,
		pts: 9,
		trb: 3.8,
		ast: 2,
		off: 72,
		def: 66,
		space: 75,
		create: 80,
		usage: 61,
		reb: 70,
	},
	{
		id: "mitchdo01",
		name: "Donovan Mitchell",
		team: "CLE",
		pos: "G",
		price: 10,
		mpg: 31.4,
		per: 20.9,
		vorp: 3.2,
		pts: 24,
		trb: 4.5,
		ast: 5,
		off: 99,
		def: 70,
		space: 94,
		create: 99,
		usage: 91,
		reb: 78,
	},
	{
		id: "mobleev01",
		name: "Evan Mobley",
		team: "CLE",
		pos: "PF",
		price: 10,
		mpg: 30.5,
		per: 22.3,
		vorp: 3.6,
		pts: 18.5,
		trb: 9.3,
		ast: 3.2,
		off: 99,
		def: 81,
		space: 64,
		create: 95,
		usage: 75,
		reb: 99,
	},
	{
		id: "hardeja01",
		name: "James Harden",
		team: "CLE",
		pos: "G",
		price: 8,
		mpg: 35.3,
		per: 20,
		vorp: 4.4,
		pts: 22.8,
		trb: 5.8,
		ast: 8.7,
		off: 99,
		def: 74,
		space: 91,
		create: 99,
		usage: 89,
		reb: 85,
	},
	{
		id: "allenja01",
		name: "Jarrett Allen",
		team: "CLE",
		pos: "C",
		price: 8,
		mpg: 28,
		per: 22.1,
		vorp: 3.6,
		pts: 13.5,
		trb: 9.7,
		ast: 1.9,
		off: 96,
		def: 78,
		space: 35,
		create: 81,
		usage: 59,
		reb: 99,
	},
	{
		id: "schrode01",
		name: "Dennis Schroder",
		team: "CLE",
		pos: "G",
		price: 6,
		mpg: 33.6,
		per: 16,
		vorp: 0.4,
		pts: 18.4,
		trb: 3,
		ast: 6.6,
		off: 92,
		def: 60,
		space: 84,
		create: 99,
		usage: 76,
		reb: 70,
	},
	{
		id: "strusma01",
		name: "Max Strus",
		team: "CLE",
		pos: "SF",
		price: 6,
		mpg: 25.5,
		per: 12.6,
		vorp: 1.1,
		pts: 9.4,
		trb: 4.3,
		ast: 3.2,
		off: 92,
		def: 66,
		space: 90,
		create: 86,
		usage: 57,
		reb: 76,
	},
	{
		id: "merrisa01",
		name: "Sam Merrill",
		team: "CLE",
		pos: "SG",
		price: 4,
		mpg: 19.7,
		per: 11.1,
		vorp: 0.8,
		pts: 7.2,
		trb: 2.2,
		ast: 1.5,
		off: 89,
		def: 66,
		space: 94,
		create: 77,
		usage: 56,
		reb: 65,
	},
	{
		id: "tysonja01",
		name: "Jaylon Tyson",
		team: "CLE",
		pos: "SG",
		price: 4,
		mpg: 9.6,
		per: 11.1,
		vorp: -0.1,
		pts: 3.6,
		trb: 2,
		ast: 0.9,
		off: 74,
		def: 66,
		space: 71,
		create: 76,
		usage: 62,
		reb: 70,
	},
	{
		id: "nancela02",
		name: "Larry Nance Jr.",
		team: "CLE",
		pos: "FC",
		price: 2,
		mpg: 19.3,
		per: 16,
		vorp: 0.4,
		pts: 8.5,
		trb: 4.3,
		ast: 1.6,
		off: 82,
		def: 72,
		space: 69,
		create: 77,
		usage: 59,
		reb: 78,
	},
	{
		id: "bryanth01",
		name: "Thomas Bryant",
		team: "CLE",
		pos: "C",
		price: 2,
		mpg: 11.5,
		per: 15.8,
		vorp: 0.1,
		pts: 4.1,
		trb: 3.2,
		ast: 0.4,
		off: 75,
		def: 72,
		space: 65,
		create: 69,
		usage: 54,
		reb: 77,
	},
	{
		id: "irvinky01",
		name: "Kyrie Irving",
		team: "DAL",
		pos: "G",
		price: 10,
		mpg: 36.1,
		per: 19.9,
		vorp: 2.5,
		pts: 24.7,
		trb: 4.8,
		ast: 4.6,
		off: 99,
		def: 65,
		space: 88,
		create: 99,
		usage: 84,
		reb: 75,
	},
	{
		id: "aldamsa01",
		name: "Santi Aldama",
		team: "DAL",
		pos: "PF",
		price: 10,
		mpg: 25.5,
		per: 16.8,
		vorp: 2.2,
		pts: 12.5,
		trb: 6.4,
		ast: 2.9,
		off: 99,
		def: 73,
		space: 80,
		create: 89,
		usage: 65,
		reb: 88,
	},
	{
		id: "flaggco01",
		name: "Cooper Flagg",
		team: "DAL",
		pos: "SF",
		price: 8,
		mpg: 33.5,
		per: 17.9,
		vorp: 2,
		pts: 21,
		trb: 6.7,
		ast: 4.5,
		off: 92,
		def: 73,
		space: 64,
		create: 98,
		usage: 83,
		reb: 85,
	},
	{
		id: "thompkl01",
		name: "Klay Thompson",
		team: "DAL",
		pos: "GF",
		price: 8,
		mpg: 27.3,
		per: 12.9,
		vorp: 0.5,
		pts: 14,
		trb: 3.4,
		ast: 2,
		off: 98,
		def: 60,
		space: 99,
		create: 80,
		usage: 72,
		reb: 66,
	},
	{
		id: "washipj01",
		name: "P.J. Washington",
		team: "DAL",
		pos: "FC",
		price: 6,
		mpg: 32.2,
		per: 14,
		vorp: 0.5,
		pts: 14.7,
		trb: 7.8,
		ast: 2.3,
		off: 83,
		def: 72,
		space: 73,
		create: 82,
		usage: 69,
		reb: 89,
	},
	{
		id: "willibr03",
		name: "Brandon Williams",
		team: "DAL",
		pos: "PG",
		price: 6,
		mpg: 14.8,
		per: 18.3,
		vorp: 0.4,
		pts: 8.3,
		trb: 1.8,
		ast: 2.3,
		off: 87,
		def: 67,
		space: 63,
		create: 89,
		usage: 74,
		reb: 69,
	},
	{
		id: "marshna01",
		name: "Naji Marshall",
		team: "DAL",
		pos: "SF",
		price: 4,
		mpg: 27.8,
		per: 15.1,
		vorp: 0.6,
		pts: 13.2,
		trb: 4.8,
		ast: 3,
		off: 83,
		def: 67,
		space: 64,
		create: 87,
		usage: 68,
		reb: 77,
	},
	{
		id: "middlkh01",
		name: "Khris Middleton",
		team: "DAL",
		pos: "GF",
		price: 4,
		mpg: 23.2,
		per: 17.8,
		vorp: 0.6,
		pts: 12.6,
		trb: 3.7,
		ast: 4.4,
		off: 88,
		def: 67,
		space: 70,
		create: 94,
		usage: 72,
		reb: 72,
	},
	{
		id: "gaffoda01",
		name: "Daniel Gafford",
		team: "DAL",
		pos: "FC",
		price: 2,
		mpg: 21.5,
		per: 24.7,
		vorp: 1.8,
		pts: 12.3,
		trb: 6.8,
		ast: 1.4,
		off: 87,
		def: 77,
		space: 35,
		create: 77,
		usage: 67,
		reb: 91,
	},
	{
		id: "nembhry01",
		name: "Ryan Nembhard",
		team: "DAL",
		pos: "PG",
		price: 2,
		mpg: 19.5,
		per: 10.9,
		vorp: -0.6,
		pts: 6.6,
		trb: 2.2,
		ast: 5.3,
		off: 76,
		def: 56,
		space: 69,
		create: 99,
		usage: 63,
		reb: 69,
	},
	{
		id: "jokicni01",
		name: "Nikola Jokic",
		team: "DEN",
		pos: "C",
		price: 10,
		mpg: 36.7,
		per: 32,
		vorp: 9.8,
		pts: 29.6,
		trb: 12.7,
		ast: 10.2,
		off: 99,
		def: 86,
		space: 68,
		create: 99,
		usage: 88,
		reb: 99,
	},
	{
		id: "murraja01",
		name: "Jamal Murray",
		team: "DEN",
		pos: "G",
		price: 10,
		mpg: 36.1,
		per: 17.8,
		vorp: 1.7,
		pts: 21.4,
		trb: 3.9,
		ast: 6,
		off: 99,
		def: 64,
		space: 86,
		create: 99,
		usage: 77,
		reb: 78,
	},
	{
		id: "valanjo01",
		name: "Jonas Valanciunas",
		team: "DEN",
		pos: "C",
		price: 8,
		mpg: 20.1,
		per: 20.6,
		vorp: 0.6,
		pts: 11.5,
		trb: 8.2,
		ast: 2.2,
		off: 91,
		def: 67,
		space: 50,
		create: 86,
		usage: 76,
		reb: 99,
	},
	{
		id: "gordoaa01",
		name: "Aaron Gordon",
		team: "DEN",
		pos: "F",
		price: 8,
		mpg: 28.4,
		per: 17,
		vorp: 1.2,
		pts: 14.7,
		trb: 4.8,
		ast: 3.2,
		off: 97,
		def: 61,
		space: 75,
		create: 90,
		usage: 66,
		reb: 85,
	},
	{
		id: "johnsca02",
		name: "Cameron Johnson",
		team: "DEN",
		pos: "F",
		price: 6,
		mpg: 31.6,
		per: 18.2,
		vorp: 2.3,
		pts: 18.8,
		trb: 4.3,
		ast: 3.4,
		off: 99,
		def: 66,
		space: 91,
		create: 91,
		usage: 74,
		reb: 75,
	},
	{
		id: "braunch01",
		name: "Christian Braun",
		team: "DEN",
		pos: "SG",
		price: 6,
		mpg: 33.9,
		per: 16,
		vorp: 1.6,
		pts: 15.4,
		trb: 5.2,
		ast: 2.6,
		off: 89,
		def: 66,
		space: 64,
		create: 86,
		usage: 59,
		reb: 83,
	},
	{
		id: "brownbr01",
		name: "Bruce Brown",
		team: "DEN",
		pos: "GF",
		price: 4,
		mpg: 19.6,
		per: 12.3,
		vorp: 0,
		pts: 8.4,
		trb: 3.8,
		ast: 1.6,
		off: 72,
		def: 70,
		space: 61,
		create: 82,
		usage: 66,
		reb: 76,
	},
	{
		id: "jonesty01",
		name: "Tyus Jones",
		team: "DEN",
		pos: "PG",
		price: 4,
		mpg: 26.8,
		per: 14.5,
		vorp: 1.1,
		pts: 10.2,
		trb: 2.4,
		ast: 5.3,
		off: 89,
		def: 59,
		space: 79,
		create: 95,
		usage: 60,
		reb: 66,
	},
	{
		id: "strawju01",
		name: "Julian Strawther",
		team: "DEN",
		pos: "GF",
		price: 2,
		mpg: 21.3,
		per: 9.5,
		vorp: -0.9,
		pts: 9,
		trb: 2.2,
		ast: 1.3,
		off: 76,
		def: 60,
		space: 74,
		create: 75,
		usage: 63,
		reb: 67,
	},
	{
		id: "watsope01",
		name: "Peyton Watson",
		team: "DEN",
		pos: "GF",
		price: 2,
		mpg: 24.4,
		per: 11.4,
		vorp: 0.1,
		pts: 8.1,
		trb: 3.4,
		ast: 1.4,
		off: 75,
		def: 72,
		space: 66,
		create: 75,
		usage: 55,
		reb: 74,
	},
	{
		id: "cunnica01",
		name: "Cade Cunningham",
		team: "DET",
		pos: "G",
		price: 10,
		mpg: 35,
		per: 20.6,
		vorp: 3.7,
		pts: 26.1,
		trb: 6.1,
		ast: 9.1,
		off: 99,
		def: 74,
		space: 74,
		create: 99,
		usage: 96,
		reb: 86,
	},
	{
		id: "durenja01",
		name: "Jalen Duren",
		team: "DET",
		pos: "C",
		price: 10,
		mpg: 26.1,
		per: 21.4,
		vorp: 2.7,
		pts: 11.8,
		trb: 10.3,
		ast: 2.7,
		off: 92,
		def: 80,
		space: 40,
		create: 84,
		usage: 60,
		reb: 99,
	},
	{
		id: "collijo01",
		name: "John Collins",
		team: "DET",
		pos: "PF",
		price: 8,
		mpg: 30.5,
		per: 19,
		vorp: 0.9,
		pts: 19,
		trb: 8.2,
		ast: 2,
		off: 91,
		def: 68,
		space: 68,
		create: 82,
		usage: 77,
		reb: 90,
	},
	{
		id: "reedpa01",
		name: "Paul Reed",
		team: "DET",
		pos: "FC",
		price: 8,
		mpg: 9.7,
		per: 18.6,
		vorp: 0.5,
		pts: 4.1,
		trb: 2.7,
		ast: 1,
		off: 78,
		def: 93,
		space: 54,
		create: 75,
		usage: 64,
		reb: 83,
	},
	{
		id: "thompau01",
		name: "Ausar Thompson",
		team: "DET",
		pos: "SF",
		price: 6,
		mpg: 22.5,
		per: 17.2,
		vorp: 1.2,
		pts: 10.1,
		trb: 5.1,
		ast: 2.3,
		off: 78,
		def: 86,
		space: 51,
		create: 85,
		usage: 66,
		reb: 88,
	},
	{
		id: "joeis01",
		name: "Isaiah Joe",
		team: "DET",
		pos: "SG",
		price: 6,
		mpg: 21.7,
		per: 14,
		vorp: 1.4,
		pts: 10.2,
		trb: 2.6,
		ast: 1.6,
		off: 93,
		def: 67,
		space: 99,
		create: 78,
		usage: 62,
		reb: 69,
	},
	{
		id: "huertke01",
		name: "Kevin Huerter",
		team: "DET",
		pos: "GF",
		price: 4,
		mpg: 20.9,
		per: 10.6,
		vorp: -0.1,
		pts: 7.9,
		trb: 2.8,
		ast: 1.7,
		off: 80,
		def: 67,
		space: 88,
		create: 80,
		usage: 62,
		reb: 70,
	},
	{
		id: "robindu01",
		name: "Duncan Robinson",
		team: "DET",
		pos: "GF",
		price: 4,
		mpg: 24.1,
		per: 11.8,
		vorp: 0.1,
		pts: 11,
		trb: 2.3,
		ast: 2.4,
		off: 88,
		def: 60,
		space: 98,
		create: 82,
		usage: 66,
		reb: 62,
	},
	{
		id: "leverca01",
		name: "Caris LeVert",
		team: "DET",
		pos: "GF",
		price: 2,
		mpg: 23.8,
		per: 14.4,
		vorp: 0.7,
		pts: 10.2,
		trb: 2.8,
		ast: 3.7,
		off: 85,
		def: 70,
		space: 79,
		create: 91,
		usage: 64,
		reb: 68,
	},
	{
		id: "hollaro01",
		name: "Ron Holland",
		team: "DET",
		pos: "SF",
		price: 2,
		mpg: 15.6,
		per: 11.1,
		vorp: -0.3,
		pts: 6.4,
		trb: 2.7,
		ast: 1,
		off: 69,
		def: 73,
		space: 56,
		create: 75,
		usage: 64,
		reb: 73,
	},
	{
		id: "curryst01",
		name: "Stephen Curry",
		team: "GS",
		pos: "PG",
		price: 10,
		mpg: 32.2,
		per: 21.5,
		vorp: 4.8,
		pts: 24.5,
		trb: 4.4,
		ast: 6,
		off: 99,
		def: 70,
		space: 99,
		create: 99,
		usage: 89,
		reb: 76,
	},
	{
		id: "butleji01",
		name: "Jimmy Butler",
		team: "GS",
		pos: "GF",
		price: 10,
		mpg: 30.6,
		per: 22.8,
		vorp: 1.3,
		pts: 17,
		trb: 5.2,
		ast: 4.8,
		off: 99,
		def: 74,
		space: 56,
		create: 99,
		usage: 70,
		reb: 81,
	},
	{
		id: "porzikr01",
		name: "Kristaps Porzingis",
		team: "GS",
		pos: "FC",
		price: 8,
		mpg: 28.8,
		per: 22.3,
		vorp: 2.1,
		pts: 19.5,
		trb: 6.8,
		ast: 2.1,
		off: 99,
		def: 76,
		space: 79,
		create: 89,
		usage: 81,
		reb: 87,
	},
	{
		id: "meltode01",
		name: "De'Anthony Melton",
		team: "GS",
		pos: "G",
		price: 8,
		mpg: 20.2,
		per: 13.3,
		vorp: 0,
		pts: 10.3,
		trb: 3.3,
		ast: 2.8,
		off: 82,
		def: 75,
		space: 81,
		create: 90,
		usage: 76,
		reb: 73,
	},
	{
		id: "podzibr01",
		name: "Brandin Podziemski",
		team: "GS",
		pos: "SG",
		price: 6,
		mpg: 26.8,
		per: 14.4,
		vorp: 1.2,
		pts: 11.7,
		trb: 5.1,
		ast: 3.4,
		off: 87,
		def: 73,
		space: 80,
		create: 90,
		usage: 64,
		reb: 82,
	},
	{
		id: "postqu01",
		name: "Quinten Post",
		team: "GS",
		pos: "PF",
		price: 6,
		mpg: 16.3,
		per: 14.2,
		vorp: 0.4,
		pts: 8.1,
		trb: 3.5,
		ast: 1.3,
		off: 91,
		def: 68,
		space: 78,
		create: 77,
		usage: 67,
		reb: 73,
	},
	{
		id: "horfoal01",
		name: "Al Horford",
		team: "GS",
		pos: "C",
		price: 4,
		mpg: 27.7,
		per: 12.9,
		vorp: 1.3,
		pts: 9,
		trb: 6.2,
		ast: 2.1,
		off: 87,
		def: 74,
		space: 85,
		create: 80,
		usage: 55,
		reb: 82,
	},
	{
		id: "paytoga02",
		name: "Gary Payton II",
		team: "GS",
		pos: "GF",
		price: 4,
		mpg: 15,
		per: 16.2,
		vorp: 0.8,
		pts: 6.5,
		trb: 3,
		ast: 1.3,
		off: 80,
		def: 81,
		space: 64,
		create: 77,
		usage: 60,
		reb: 75,
	},
	{
		id: "greendr01",
		name: "Draymond Green",
		team: "GS",
		pos: "F",
		price: 2,
		mpg: 29.2,
		per: 12.4,
		vorp: 1.3,
		pts: 9,
		trb: 6.1,
		ast: 5.6,
		off: 74,
		def: 86,
		space: 70,
		create: 99,
		usage: 59,
		reb: 83,
	},
	{
		id: "moodymo01",
		name: "Moses Moody",
		team: "GS",
		pos: "SG",
		price: 2,
		mpg: 22.3,
		per: 12.4,
		vorp: 0.5,
		pts: 9.8,
		trb: 2.6,
		ast: 1.3,
		off: 83,
		def: 70,
		space: 83,
		create: 78,
		usage: 62,
		reb: 70,
	},
	{
		id: "sengual01",
		name: "Alperen Sengun",
		team: "HOU",
		pos: "C",
		price: 10,
		mpg: 31.5,
		per: 21.4,
		vorp: 3.9,
		pts: 19.1,
		trb: 10.3,
		ast: 4.9,
		off: 99,
		def: 83,
		space: 57,
		create: 99,
		usage: 81,
		reb: 99,
	},
	{
		id: "duranke01",
		name: "Kevin Durant",
		team: "HOU",
		pos: "GF",
		price: 10,
		mpg: 36.5,
		per: 21.2,
		vorp: 3,
		pts: 26.6,
		trb: 6,
		ast: 4.2,
		off: 99,
		def: 66,
		space: 75,
		create: 99,
		usage: 87,
		reb: 81,
	},
	{
		id: "thompam01",
		name: "Amen Thompson",
		team: "HOU",
		pos: "GF",
		price: 8,
		mpg: 32.2,
		per: 18.7,
		vorp: 3.4,
		pts: 14.1,
		trb: 8.2,
		ast: 3.8,
		off: 93,
		def: 85,
		space: 55,
		create: 93,
		usage: 63,
		reb: 99,
	},
	{
		id: "easonta01",
		name: "Tari Eason",
		team: "HOU",
		pos: "PF",
		price: 8,
		mpg: 24.9,
		per: 18.5,
		vorp: 2,
		pts: 12,
		trb: 6.4,
		ast: 1.5,
		off: 93,
		def: 85,
		space: 70,
		create: 79,
		usage: 67,
		reb: 90,
	},
	{
		id: "vanvlfr01",
		name: "Fred VanVleet",
		team: "HOU",
		pos: "G",
		price: 6,
		mpg: 35.2,
		per: 12.8,
		vorp: 1.5,
		pts: 14.1,
		trb: 3.7,
		ast: 5.6,
		off: 91,
		def: 75,
		space: 94,
		create: 99,
		usage: 63,
		reb: 74,
	},
	{
		id: "sheppre01",
		name: "Reed Sheppard",
		team: "HOU",
		pos: "G",
		price: 6,
		mpg: 12.6,
		per: 9.7,
		vorp: 0.1,
		pts: 4.4,
		trb: 1.5,
		ast: 1.4,
		off: 81,
		def: 75,
		space: 84,
		create: 79,
		usage: 63,
		reb: 66,
	},
	{
		id: "smithja05",
		name: "Jabari Smith Jr.",
		team: "HOU",
		pos: "PF",
		price: 4,
		mpg: 30.1,
		per: 12.6,
		vorp: 0.6,
		pts: 12.2,
		trb: 7,
		ast: 1.1,
		off: 84,
		def: 68,
		space: 82,
		create: 75,
		usage: 60,
		reb: 90,
	},
	{
		id: "bogdabo01",
		name: "Bogdan Bogdanovic",
		team: "HOU",
		pos: "SG",
		price: 4,
		mpg: 24.9,
		per: 7.6,
		vorp: -0.4,
		pts: 10,
		trb: 2.8,
		ast: 2,
		off: 74,
		def: 63,
		space: 88,
		create: 82,
		usage: 66,
		reb: 67,
	},
	{
		id: "smartma01",
		name: "Marcus Smart",
		team: "HOU",
		pos: "G",
		price: 2,
		mpg: 21.1,
		per: 11.3,
		vorp: 0.1,
		pts: 8.7,
		trb: 2.3,
		ast: 3.7,
		off: 75,
		def: 72,
		space: 77,
		create: 92,
		usage: 68,
		reb: 63,
	},
	{
		id: "capelca01",
		name: "Clint Capela",
		team: "HOU",
		pos: "C",
		price: 2,
		mpg: 21.4,
		per: 17.7,
		vorp: 0.3,
		pts: 8.9,
		trb: 8.5,
		ast: 1.1,
		off: 74,
		def: 72,
		space: 35,
		create: 69,
		usage: 61,
		reb: 99,
	},
	{
		id: "halibty01",
		name: "Tyrese Haliburton",
		team: "IND",
		pos: "G",
		price: 10,
		mpg: 33.6,
		per: 21.8,
		vorp: 4.9,
		pts: 18.6,
		trb: 3.5,
		ast: 9.2,
		off: 99,
		def: 72,
		space: 99,
		create: 99,
		usage: 71,
		reb: 70,
	},
	{
		id: "siakapa01",
		name: "Pascal Siakam",
		team: "IND",
		pos: "PF",
		price: 10,
		mpg: 32.7,
		per: 19.2,
		vorp: 2.4,
		pts: 20.2,
		trb: 6.9,
		ast: 3.4,
		off: 99,
		def: 68,
		space: 66,
		create: 96,
		usage: 77,
		reb: 85,
	},
	{
		id: "mccontj01",
		name: "T.J. McConnell",
		team: "IND",
		pos: "PG",
		price: 8,
		mpg: 17.9,
		per: 18.4,
		vorp: 1.2,
		pts: 9.1,
		trb: 2.4,
		ast: 4.4,
		off: 95,
		def: 74,
		space: 52,
		create: 99,
		usage: 75,
		reb: 67,
	},
	{
		id: "zubaciv01",
		name: "Ivica Zubac",
		team: "IND",
		pos: "C",
		price: 8,
		mpg: 32.8,
		per: 22.3,
		vorp: 3.4,
		pts: 16.8,
		trb: 12.6,
		ast: 2.7,
		off: 96,
		def: 77,
		space: 35,
		create: 85,
		usage: 67,
		reb: 99,
	},
	{
		id: "toppiob01",
		name: "Obi Toppin",
		team: "IND",
		pos: "PF",
		price: 6,
		mpg: 19.6,
		per: 17.4,
		vorp: 1.4,
		pts: 10.5,
		trb: 4,
		ast: 1.6,
		off: 97,
		def: 68,
		space: 76,
		create: 81,
		usage: 68,
		reb: 75,
	},
	{
		id: "nembhan01",
		name: "Andrew Nembhard",
		team: "IND",
		pos: "G",
		price: 6,
		mpg: 28.9,
		per: 11.7,
		vorp: -0.1,
		pts: 10,
		trb: 3.3,
		ast: 5,
		off: 79,
		def: 67,
		space: 68,
		create: 99,
		usage: 60,
		reb: 68,
	},
	{
		id: "huffja01",
		name: "Jay Huff",
		team: "IND",
		pos: "C",
		price: 4,
		mpg: 11.7,
		per: 18.2,
		vorp: 1.1,
		pts: 6.9,
		trb: 2,
		ast: 0.6,
		off: 94,
		def: 74,
		space: 76,
		create: 73,
		usage: 67,
		reb: 68,
	},
	{
		id: "oubreke01",
		name: "Kelly Oubre Jr.",
		team: "IND",
		pos: "SF",
		price: 4,
		mpg: 34.6,
		per: 13.5,
		vorp: -0.1,
		pts: 15.1,
		trb: 6.1,
		ast: 1.8,
		off: 79,
		def: 67,
		space: 71,
		create: 79,
		usage: 66,
		reb: 82,
	},
	{
		id: "nesmiaa01",
		name: "Aaron Nesmith",
		team: "IND",
		pos: "SF",
		price: 2,
		mpg: 24.9,
		per: 14.6,
		vorp: 0.4,
		pts: 12,
		trb: 4,
		ast: 1.2,
		off: 85,
		def: 64,
		space: 85,
		create: 77,
		usage: 62,
		reb: 74,
	},
	{
		id: "walkeja02",
		name: "Jarace Walker",
		team: "IND",
		pos: "PF",
		price: 2,
		mpg: 15.8,
		per: 11.9,
		vorp: 0.3,
		pts: 6.1,
		trb: 3.1,
		ast: 1.5,
		off: 76,
		def: 71,
		space: 71,
		create: 79,
		usage: 62,
		reb: 73,
	},
	{
		id: "ingrabr01",
		name: "Brandon Ingram",
		team: "LAC",
		pos: "F",
		price: 10,
		mpg: 33.1,
		per: 16,
		vorp: 0.3,
		pts: 22.2,
		trb: 5.6,
		ast: 5.2,
		off: 99,
		def: 61,
		space: 74,
		create: 99,
		usage: 90,
		reb: 80,
	},
	{
		id: "garlada01",
		name: "Darius Garland",
		team: "LAC",
		pos: "G",
		price: 10,
		mpg: 30.7,
		per: 19.9,
		vorp: 3,
		pts: 20.6,
		trb: 2.9,
		ast: 6.7,
		off: 99,
		def: 63,
		space: 86,
		create: 99,
		usage: 83,
		reb: 67,
	},
	{
		id: "lopezbr01",
		name: "Brook Lopez",
		team: "LAC",
		pos: "C",
		price: 8,
		mpg: 31.8,
		per: 14.8,
		vorp: 1.8,
		pts: 13,
		trb: 5,
		ast: 1.8,
		off: 90,
		def: 73,
		space: 81,
		create: 76,
		usage: 59,
		reb: 73,
	},
	{
		id: "mathube01",
		name: "Bennedict Mathurin",
		team: "LAC",
		pos: "GF",
		price: 8,
		mpg: 29.8,
		per: 13.6,
		vorp: -0.5,
		pts: 16.1,
		trb: 5.3,
		ast: 1.9,
		off: 82,
		def: 61,
		space: 70,
		create: 84,
		usage: 74,
		reb: 82,
	},
	{
		id: "dunnkr01",
		name: "Kris Dunn",
		team: "LAC",
		pos: "PG",
		price: 6,
		mpg: 24.1,
		per: 11.3,
		vorp: 1.2,
		pts: 6.4,
		trb: 3.4,
		ast: 2.8,
		off: 72,
		def: 85,
		space: 70,
		create: 83,
		usage: 52,
		reb: 69,
	},
	{
		id: "dickgr01",
		name: "Gradey Dick",
		team: "LAC",
		pos: "SG",
		price: 6,
		mpg: 29.4,
		per: 10.9,
		vorp: -0.5,
		pts: 14.4,
		trb: 3.6,
		ast: 1.8,
		off: 78,
		def: 62,
		space: 82,
		create: 81,
		usage: 70,
		reb: 71,
	},
	{
		id: "omierno01",
		name: "Norchad Omier",
		team: "LAC",
		pos: "PF",
		price: 4,
		mpg: 4,
		per: 31.5,
		vorp: 0,
		pts: 2.8,
		trb: 1.2,
		ast: 0.3,
		off: 93,
		def: 65,
		space: 54,
		create: 71,
		usage: 70,
		reb: 71,
	},
	{
		id: "jacksis01",
		name: "Isaiah Jackson",
		team: "LAC",
		pos: "C",
		price: 4,
		mpg: 16.8,
		per: 18.2,
		vorp: 0.1,
		pts: 7,
		trb: 5.6,
		ast: 1,
		off: 70,
		def: 80,
		space: 43,
		create: 72,
		usage: 63,
		reb: 88,
	},
	{
		id: "sandeko01",
		name: "Kobe Sanders",
		team: "LAC",
		pos: "SG",
		price: 2,
		mpg: 19.9,
		per: 10,
		vorp: -0.3,
		pts: 7.3,
		trb: 2.3,
		ast: 1.6,
		off: 73,
		def: 65,
		space: 74,
		create: 76,
		usage: 60,
		reb: 63,
	},
	{
		id: "jonesde02",
		name: "Derrick Jones Jr.",
		team: "LAC",
		pos: "F",
		price: 2,
		mpg: 24.3,
		per: 13.5,
		vorp: 0.8,
		pts: 10.1,
		trb: 3.4,
		ast: 0.8,
		off: 76,
		def: 71,
		space: 72,
		create: 70,
		usage: 60,
		reb: 68,
	},
	{
		id: "doncilu01",
		name: "Luka Doncic",
		team: "LAL",
		pos: "G",
		price: 10,
		mpg: 35.7,
		per: 24.2,
		vorp: 1.8,
		pts: 28.1,
		trb: 8.3,
		ast: 7.8,
		off: 99,
		def: 75,
		space: 91,
		create: 99,
		usage: 96,
		reb: 96,
	},
	{
		id: "jamesle01",
		name: "LeBron James",
		team: "LAL",
		pos: "GF",
		price: 10,
		mpg: 34.9,
		per: 22.7,
		vorp: 4.7,
		pts: 24.4,
		trb: 7.8,
		ast: 8.2,
		off: 99,
		def: 73,
		space: 71,
		create: 99,
		usage: 90,
		reb: 89,
	},
	{
		id: "reaveau01",
		name: "Austin Reaves",
		team: "LAL",
		pos: "SG",
		price: 8,
		mpg: 34.9,
		per: 18.1,
		vorp: 2.6,
		pts: 20.2,
		trb: 4.5,
		ast: 5.8,
		off: 99,
		def: 66,
		space: 95,
		create: 99,
		usage: 76,
		reb: 81,
	},
	{
		id: "mamuksa01",
		name: "Sandro Mamukelashvili",
		team: "LAL",
		pos: "FC",
		price: 8,
		mpg: 11.2,
		per: 19.7,
		vorp: 0.7,
		pts: 6.3,
		trb: 3.1,
		ast: 0.8,
		off: 97,
		def: 66,
		space: 75,
		create: 81,
		usage: 70,
		reb: 79,
	},
	{
		id: "grimequ01",
		name: "Quentin Grimes",
		team: "LAL",
		pos: "SG",
		price: 6,
		mpg: 22.8,
		per: 13.3,
		vorp: 0.5,
		pts: 10.2,
		trb: 3.8,
		ast: 2.1,
		off: 88,
		def: 67,
		space: 85,
		create: 86,
		usage: 65,
		reb: 73,
	},
	{
		id: "sextoco01",
		name: "Collin Sexton",
		team: "LAL",
		pos: "G",
		price: 6,
		mpg: 27.9,
		per: 16.6,
		vorp: 0.6,
		pts: 18.4,
		trb: 2.7,
		ast: 4.2,
		off: 94,
		def: 54,
		space: 71,
		create: 98,
		usage: 83,
		reb: 69,
	},
	{
		id: "hachiru01",
		name: "Rui Hachimura",
		team: "LAL",
		pos: "PF",
		price: 4,
		mpg: 31.7,
		per: 13.6,
		vorp: 0.6,
		pts: 13.1,
		trb: 5,
		ast: 1.4,
		off: 88,
		def: 62,
		space: 82,
		create: 74,
		usage: 59,
		reb: 75,
	},
	{
		id: "knechda01",
		name: "Dalton Knecht",
		team: "LAL",
		pos: "SF",
		price: 4,
		mpg: 19.2,
		per: 12.7,
		vorp: 0.1,
		pts: 9.1,
		trb: 2.8,
		ast: 0.8,
		off: 87,
		def: 57,
		space: 83,
		create: 73,
		usage: 65,
		reb: 68,
	},
	{
		id: "kesslwa01",
		name: "Walker Kessler",
		team: "LAL",
		pos: "C",
		price: 2,
		mpg: 30,
		per: 20,
		vorp: 1.7,
		pts: 11.1,
		trb: 12.2,
		ast: 1.7,
		off: 82,
		def: 75,
		space: 51,
		create: 74,
		usage: 54,
		reb: 99,
	},
	{
		id: "smithni01",
		name: "Nick Smith Jr.",
		team: "LAL",
		pos: "SG",
		price: 2,
		mpg: 22.8,
		per: 8.3,
		vorp: -1.3,
		pts: 9.9,
		trb: 2.1,
		ast: 2.4,
		off: 78,
		def: 51,
		space: 82,
		create: 82,
		usage: 70,
		reb: 61,
	},
	{
		id: "jeromty01",
		name: "Ty Jerome",
		team: "MEM",
		pos: "SG",
		price: 10,
		mpg: 19.9,
		per: 21,
		vorp: 2.2,
		pts: 12.5,
		trb: 2.5,
		ast: 3.4,
		off: 99,
		def: 71,
		space: 79,
		create: 95,
		usage: 76,
		reb: 66,
	},
	{
		id: "cowarce01",
		name: "Cedric Coward",
		team: "MEM",
		pos: "SG",
		price: 10,
		mpg: 25.8,
		per: 15.3,
		vorp: 0.7,
		pts: 13.6,
		trb: 5.9,
		ast: 2.8,
		off: 88,
		def: 66,
		space: 77,
		create: 88,
		usage: 71,
		reb: 84,
	},
	{
		id: "pippesc02",
		name: "Scotty Pippen Jr.",
		team: "MEM",
		pos: "PG",
		price: 8,
		mpg: 21.3,
		per: 15.8,
		vorp: 1.7,
		pts: 9.9,
		trb: 3.3,
		ast: 4.4,
		off: 84,
		def: 77,
		space: 68,
		create: 96,
		usage: 66,
		reb: 73,
	},
	{
		id: "edeyza01",
		name: "Zach Edey",
		team: "MEM",
		pos: "C",
		price: 8,
		mpg: 21.5,
		per: 18.2,
		vorp: 0.7,
		pts: 9.2,
		trb: 8.3,
		ast: 1,
		off: 82,
		def: 74,
		space: 53,
		create: 72,
		usage: 60,
		reb: 98,
	},
	{
		id: "clarkbr01",
		name: "Brandon Clarke",
		team: "MEM",
		pos: "PF",
		price: 6,
		mpg: 18.9,
		per: 17.6,
		vorp: 0.9,
		pts: 8.3,
		trb: 5.1,
		ast: 1,
		off: 82,
		def: 74,
		space: 46,
		create: 74,
		usage: 58,
		reb: 83,
	},
	{
		id: "anthoco01",
		name: "Cole Anthony",
		team: "MEM",
		pos: "PG",
		price: 6,
		mpg: 18.4,
		per: 14.2,
		vorp: 0.7,
		pts: 9.4,
		trb: 3,
		ast: 2.9,
		off: 78,
		def: 71,
		space: 65,
		create: 88,
		usage: 78,
		reb: 78,
	},
	{
		id: "spencca01",
		name: "Cam Spencer",
		team: "MEM",
		pos: "SG",
		price: 4,
		mpg: 10.1,
		per: 14.2,
		vorp: 0.2,
		pts: 4.2,
		trb: 1.2,
		ast: 1.4,
		off: 84,
		def: 64,
		space: 80,
		create: 80,
		usage: 58,
		reb: 61,
	},
	{
		id: "wellsja01",
		name: "Jaylen Wells",
		team: "MEM",
		pos: "GF",
		price: 4,
		mpg: 25.9,
		per: 10.5,
		vorp: -0.1,
		pts: 10.4,
		trb: 3.4,
		ast: 1.7,
		off: 82,
		def: 61,
		space: 81,
		create: 77,
		usage: 59,
		reb: 67,
	},
	{
		id: "smallja01",
		name: "Javon Small",
		team: "MEM",
		pos: "PG",
		price: 2,
		mpg: 20.2,
		per: 16.1,
		vorp: 0.6,
		pts: 9.7,
		trb: 3.1,
		ast: 3.7,
		off: 87,
		def: 62,
		space: 79,
		create: 90,
		usage: 66,
		reb: 73,
	},
	{
		id: "grantje01",
		name: "Jerami Grant",
		team: "MEM",
		pos: "F",
		price: 2,
		mpg: 32.4,
		per: 10.9,
		vorp: 0.1,
		pts: 14.4,
		trb: 3.5,
		ast: 2.1,
		off: 79,
		def: 65,
		space: 83,
		create: 82,
		usage: 67,
		reb: 68,
	},
	{
		id: "antetgi01",
		name: "Giannis Antetokounmpo",
		team: "MIA",
		pos: "GF",
		price: 10,
		mpg: 34.2,
		per: 30.5,
		vorp: 6.6,
		pts: 30.4,
		trb: 11.9,
		ast: 6.5,
		off: 99,
		def: 83,
		space: 49,
		create: 99,
		usage: 99,
		reb: 99,
	},
	{
		id: "adebaba01",
		name: "Bam Adebayo",
		team: "MIA",
		pos: "FC",
		price: 10,
		mpg: 34.3,
		per: 18.9,
		vorp: 2.7,
		pts: 18.1,
		trb: 9.6,
		ast: 4.3,
		off: 99,
		def: 79,
		space: 66,
		create: 97,
		usage: 76,
		reb: 99,
	},
	{
		id: "portibo01",
		name: "Bobby Portis",
		team: "MIA",
		pos: "FC",
		price: 8,
		mpg: 25.4,
		per: 17.7,
		vorp: 0.7,
		pts: 13.9,
		trb: 8.4,
		ast: 2.1,
		off: 99,
		def: 68,
		space: 71,
		create: 82,
		usage: 77,
		reb: 95,
	},
	{
		id: "wiggian01",
		name: "Andrew Wiggins",
		team: "MIA",
		pos: "F",
		price: 8,
		mpg: 30.1,
		per: 16.4,
		vorp: 1,
		pts: 17.6,
		trb: 4.6,
		ast: 2.4,
		off: 94,
		def: 68,
		space: 77,
		create: 88,
		usage: 76,
		reb: 74,
	},
	{
		id: "smithdr01",
		name: "Dru Smith",
		team: "MIA",
		pos: "SG",
		price: 6,
		mpg: 19.1,
		per: 13.3,
		vorp: 0.3,
		pts: 6.2,
		trb: 2.6,
		ast: 1.6,
		off: 80,
		def: 85,
		space: 68,
		create: 81,
		usage: 55,
		reb: 69,
	},
	{
		id: "jovicni01",
		name: "Nikola Jovic",
		team: "MIA",
		pos: "PF",
		price: 6,
		mpg: 25.1,
		per: 13.8,
		vorp: 0.7,
		pts: 10.7,
		trb: 3.9,
		ast: 2.8,
		off: 85,
		def: 69,
		space: 72,
		create: 86,
		usage: 64,
		reb: 73,
	},
	{
		id: "mitchda01",
		name: "Davion Mitchell",
		team: "MIA",
		pos: "PG",
		price: 4,
		mpg: 24.5,
		per: 7.9,
		vorp: -0.6,
		pts: 6.3,
		trb: 1.9,
		ast: 4.6,
		off: 73,
		def: 66,
		space: 75,
		create: 96,
		usage: 53,
		reb: 62,
	},
	{
		id: "fontesi01",
		name: "Simone Fontecchio",
		team: "MIA",
		pos: "SF",
		price: 4,
		mpg: 16.5,
		per: 9.7,
		vorp: -0.3,
		pts: 5.9,
		trb: 2.9,
		ast: 0.9,
		off: 79,
		def: 62,
		space: 83,
		create: 74,
		usage: 59,
		reb: 70,
	},
	{
		id: "hardati02",
		name: "Tim Hardaway Jr.",
		team: "MIA",
		pos: "GF",
		price: 2,
		mpg: 28,
		per: 9.8,
		vorp: 0,
		pts: 11,
		trb: 2.4,
		ast: 1.6,
		off: 83,
		def: 59,
		space: 90,
		create: 77,
		usage: 58,
		reb: 65,
	},
	{
		id: "larsspe01",
		name: "Pelle Larsson",
		team: "MIA",
		pos: "SG",
		price: 2,
		mpg: 14.2,
		per: 10.2,
		vorp: -0.2,
		pts: 4.6,
		trb: 1.7,
		ast: 1.2,
		off: 68,
		def: 67,
		space: 66,
		create: 78,
		usage: 56,
		reb: 62,
	},
	{
		id: "herroty01",
		name: "Tyler Herro",
		team: "MIL",
		pos: "SG",
		price: 10,
		mpg: 35.4,
		per: 19.7,
		vorp: 3.5,
		pts: 23.9,
		trb: 5.2,
		ast: 5.5,
		off: 99,
		def: 65,
		space: 99,
		create: 99,
		usage: 85,
		reb: 81,
	},
	{
		id: "rolliry01",
		name: "Ryan Rollins",
		team: "MIL",
		pos: "PG",
		price: 10,
		mpg: 14.6,
		per: 14,
		vorp: 0.3,
		pts: 6.2,
		trb: 1.9,
		ast: 1.9,
		off: 85,
		def: 73,
		space: 72,
		create: 84,
		usage: 65,
		reb: 68,
	},
	{
		id: "wareke01",
		name: "Kel'el Ware",
		team: "MIL",
		pos: "C",
		price: 8,
		mpg: 22.2,
		per: 17.4,
		vorp: 0.7,
		pts: 9.3,
		trb: 7.4,
		ast: 0.9,
		off: 84,
		def: 77,
		space: 64,
		create: 72,
		usage: 62,
		reb: 96,
	},
	{
		id: "jaqueja01",
		name: "Jaime Jaquez Jr.",
		team: "MIL",
		pos: "SF",
		price: 8,
		mpg: 20.7,
		per: 14.3,
		vorp: 0.4,
		pts: 8.6,
		trb: 4.4,
		ast: 2.5,
		off: 83,
		def: 70,
		space: 58,
		create: 87,
		usage: 68,
		reb: 77,
	},
	{
		id: "porteke02",
		name: "Kevin Porter Jr.",
		team: "MIL",
		pos: "GF",
		price: 6,
		mpg: 19.6,
		per: 12.1,
		vorp: -0.1,
		pts: 9.3,
		trb: 3.6,
		ast: 3.2,
		off: 76,
		def: 71,
		space: 62,
		create: 93,
		usage: 81,
		reb: 76,
	},
	{
		id: "kuzmaky01",
		name: "Kyle Kuzma",
		team: "MIL",
		pos: "F",
		price: 6,
		mpg: 27.7,
		per: 10.6,
		vorp: -0.7,
		pts: 15.2,
		trb: 5.8,
		ast: 2.5,
		off: 78,
		def: 58,
		space: 68,
		create: 87,
		usage: 83,
		reb: 80,
	},
	{
		id: "turnemy01",
		name: "Myles Turner",
		team: "MIL",
		pos: "C",
		price: 4,
		mpg: 30.2,
		per: 16.1,
		vorp: 1.3,
		pts: 15.6,
		trb: 6.5,
		ast: 1.5,
		off: 84,
		def: 75,
		space: 82,
		create: 80,
		usage: 70,
		reb: 84,
	},
	{
		id: "trentga02",
		name: "Gary Trent Jr.",
		team: "MIL",
		pos: "GF",
		price: 4,
		mpg: 25.6,
		per: 11.7,
		vorp: 0.2,
		pts: 11.1,
		trb: 2.3,
		ast: 1.2,
		off: 84,
		def: 64,
		space: 89,
		create: 76,
		usage: 62,
		reb: 59,
	},
	{
		id: "princta02",
		name: "Taurean Prince",
		team: "MIL",
		pos: "F",
		price: 2,
		mpg: 27.1,
		per: 9.8,
		vorp: 0.1,
		pts: 8.2,
		trb: 3.6,
		ast: 1.9,
		off: 78,
		def: 68,
		space: 84,
		create: 75,
		usage: 52,
		reb: 70,
	},
	{
		id: "greenaj01",
		name: "A.J. Green",
		team: "MIL",
		pos: "SG",
		price: 2,
		mpg: 22.7,
		per: 9.2,
		vorp: -0.1,
		pts: 7.4,
		trb: 2.4,
		ast: 1.5,
		off: 82,
		def: 62,
		space: 96,
		create: 73,
		usage: 52,
		reb: 64,
	},
	{
		id: "edwaran01",
		name: "Anthony Edwards",
		team: "MIN",
		pos: "SG",
		price: 10,
		mpg: 36.3,
		per: 20.1,
		vorp: 4.6,
		pts: 27.6,
		trb: 5.7,
		ast: 4.5,
		off: 99,
		def: 73,
		space: 99,
		create: 99,
		usage: 93,
		reb: 87,
	},
	{
		id: "ballla01",
		name: "LaMelo Ball",
		team: "MIN",
		pos: "PG",
		price: 10,
		mpg: 32,
		per: 19.1,
		vorp: 2,
		pts: 25.2,
		trb: 4.9,
		ast: 7.4,
		off: 99,
		def: 67,
		space: 99,
		create: 99,
		usage: 99,
		reb: 80,
	},
	{
		id: "divindo01",
		name: "Donte DiVincenzo",
		team: "MIN",
		pos: "SG",
		price: 8,
		mpg: 25.9,
		per: 14.1,
		vorp: 1.6,
		pts: 11.7,
		trb: 3.7,
		ast: 3.6,
		off: 91,
		def: 76,
		space: 96,
		create: 90,
		usage: 67,
		reb: 76,
	},
	{
		id: "dosunay01",
		name: "Ayo Dosunmu",
		team: "MIN",
		pos: "SG",
		price: 8,
		mpg: 30.3,
		per: 12.8,
		vorp: 0.1,
		pts: 12.3,
		trb: 3.5,
		ast: 4.5,
		off: 85,
		def: 67,
		space: 76,
		create: 96,
		usage: 61,
		reb: 71,
	},
	{
		id: "mcdanja02",
		name: "Jaden McDaniels",
		team: "MIN",
		pos: "F",
		price: 6,
		mpg: 31.9,
		per: 13.3,
		vorp: 1.4,
		pts: 12.2,
		trb: 5.7,
		ast: 2,
		off: 84,
		def: 79,
		space: 72,
		create: 81,
		usage: 60,
		reb: 79,
	},
	{
		id: "hylanbo01",
		name: "Bones Hyland",
		team: "MIN",
		pos: "G",
		price: 6,
		mpg: 11.1,
		per: 16.4,
		vorp: 0.3,
		pts: 7.2,
		trb: 1.2,
		ast: 1.4,
		off: 92,
		def: 75,
		space: 81,
		create: 87,
		usage: 89,
		reb: 64,
	},
	{
		id: "goberru01",
		name: "Rudy Gobert",
		team: "MIN",
		pos: "C",
		price: 4,
		mpg: 33.2,
		per: 18.3,
		vorp: 2.4,
		pts: 12,
		trb: 10.9,
		ast: 1.8,
		off: 79,
		def: 81,
		space: 35,
		create: 76,
		usage: 53,
		reb: 99,
	},
	{
		id: "clarkja02",
		name: "Jaylen Clark",
		team: "MIN",
		pos: "SG",
		price: 4,
		mpg: 13.1,
		per: 12,
		vorp: 0.2,
		pts: 4.1,
		trb: 1.3,
		ast: 0.7,
		off: 66,
		def: 77,
		space: 64,
		create: 69,
		usage: 51,
		reb: 62,
	},
	{
		id: "greenjo02",
		name: "Josh Green",
		team: "MIN",
		pos: "SG",
		price: 2,
		mpg: 27.8,
		per: 7.8,
		vorp: -1.1,
		pts: 7.4,
		trb: 2.5,
		ast: 1.6,
		off: 64,
		def: 66,
		space: 80,
		create: 75,
		usage: 50,
		reb: 64,
	},
	{
		id: "inglejo01",
		name: "Joe Ingles",
		team: "MIN",
		pos: "F",
		price: 2,
		mpg: 6,
		per: 2.4,
		vorp: -0.1,
		pts: 0.8,
		trb: 0.6,
		ast: 1.2,
		off: 57,
		def: 65,
		space: 75,
		create: 76,
		usage: 51,
		reb: 59,
	},
	{
		id: "willizi01",
		name: "Zion Williamson",
		team: "NOL",
		pos: "PF",
		price: 10,
		mpg: 28.6,
		per: 27.3,
		vorp: 1.9,
		pts: 24.6,
		trb: 7.2,
		ast: 5.3,
		off: 99,
		def: 71,
		space: 43,
		create: 99,
		usage: 99,
		reb: 86,
	},
	{
		id: "murrade01",
		name: "Dejounte Murray",
		team: "NOL",
		pos: "G",
		price: 10,
		mpg: 32.6,
		per: 15.4,
		vorp: 0.1,
		pts: 17.5,
		trb: 6.5,
		ast: 7.4,
		off: 92,
		def: 70,
		space: 71,
		create: 99,
		usage: 84,
		reb: 80,
	},
	{
		id: "murphtr02",
		name: "Trey Murphy III",
		team: "NOL",
		pos: "SF",
		price: 8,
		mpg: 35,
		per: 17.3,
		vorp: 1.3,
		pts: 21.2,
		trb: 5.1,
		ast: 3.5,
		off: 99,
		def: 65,
		space: 99,
		create: 96,
		usage: 76,
		reb: 77,
	},
	{
		id: "poolejo01",
		name: "Jordan Poole",
		team: "NOL",
		pos: "G",
		price: 8,
		mpg: 29.4,
		per: 16.6,
		vorp: 1.2,
		pts: 20.5,
		trb: 3,
		ast: 4.5,
		off: 99,
		def: 59,
		space: 97,
		create: 99,
		usage: 87,
		reb: 62,
	},
	{
		id: "joneshe01",
		name: "Herbert Jones",
		team: "NOL",
		pos: "F",
		price: 6,
		mpg: 32.4,
		per: 10.4,
		vorp: -0.3,
		pts: 10.3,
		trb: 3.9,
		ast: 3.3,
		off: 75,
		def: 73,
		space: 72,
		create: 87,
		usage: 56,
		reb: 69,
	},
	{
		id: "beysa01",
		name: "Saddiq Bey",
		team: "NOL",
		pos: "SF",
		price: 6,
		mpg: 31.2,
		per: 17.1,
		vorp: 1.4,
		pts: 17.7,
		trb: 5.6,
		ast: 2.5,
		off: 97,
		def: 60,
		space: 81,
		create: 85,
		usage: 71,
		reb: 81,
	},
	{
		id: "queende01",
		name: "Derik Queen",
		team: "NOL",
		pos: "C",
		price: 4,
		mpg: 25,
		per: 15.9,
		vorp: 0.6,
		pts: 11.7,
		trb: 7.1,
		ast: 3.7,
		off: 80,
		def: 74,
		space: 52,
		create: 93,
		usage: 72,
		reb: 90,
	},
	{
		id: "fearsje01",
		name: "Jeremiah Fears",
		team: "NOL",
		pos: "PG",
		price: 4,
		mpg: 25.8,
		per: 13.8,
		vorp: -0.4,
		pts: 14.3,
		trb: 3.7,
		ast: 3.4,
		off: 82,
		def: 63,
		space: 66,
		create: 93,
		usage: 80,
		reb: 72,
	},
	{
		id: "hawkijo01",
		name: "Jordan Hawkins",
		team: "NOL",
		pos: "SG",
		price: 2,
		mpg: 23.6,
		per: 9.6,
		vorp: -1.2,
		pts: 10.8,
		trb: 2.8,
		ast: 1.2,
		off: 79,
		def: 53,
		space: 79,
		create: 77,
		usage: 70,
		reb: 66,
	},
	{
		id: "matkoka01",
		name: "Karlo Matkovic",
		team: "NOL",
		pos: "PF",
		price: 2,
		mpg: 18.8,
		per: 15.6,
		vorp: 0,
		pts: 7.7,
		trb: 5,
		ast: 1.1,
		off: 75,
		def: 68,
		space: 63,
		create: 73,
		usage: 59,
		reb: 81,
	},
	{
		id: "brunsja01",
		name: "Jalen Brunson",
		team: "NYC",
		pos: "G",
		price: 10,
		mpg: 35.4,
		per: 21.6,
		vorp: 3.1,
		pts: 26,
		trb: 2.9,
		ast: 7.3,
		off: 99,
		def: 61,
		space: 76,
		create: 99,
		usage: 88,
		reb: 70,
	},
	{
		id: "townska01",
		name: "Karl-Anthony Towns",
		team: "NYC",
		pos: "FC",
		price: 10,
		mpg: 35,
		per: 23.4,
		vorp: 3.5,
		pts: 24.4,
		trb: 12.8,
		ast: 3.1,
		off: 99,
		def: 76,
		space: 73,
		create: 94,
		usage: 84,
		reb: 99,
	},
	{
		id: "bridgmi01",
		name: "Mikal Bridges",
		team: "NYC",
		pos: "GF",
		price: 8,
		mpg: 37,
		per: 14,
		vorp: 1.2,
		pts: 17.6,
		trb: 3.2,
		ast: 3.7,
		off: 98,
		def: 67,
		space: 83,
		create: 91,
		usage: 67,
		reb: 66,
	},
	{
		id: "anunoog01",
		name: "OG Anunoby",
		team: "NYC",
		pos: "F",
		price: 8,
		mpg: 36.6,
		per: 15.4,
		vorp: 1.9,
		pts: 18,
		trb: 4.8,
		ast: 2.2,
		off: 95,
		def: 75,
		space: 90,
		create: 85,
		usage: 67,
		reb: 75,
	},
	{
		id: "hartjo01",
		name: "Josh Hart",
		team: "NYC",
		pos: "GF",
		price: 6,
		mpg: 37.6,
		per: 16.5,
		vorp: 3.6,
		pts: 13.6,
		trb: 9.6,
		ast: 5.9,
		off: 91,
		def: 80,
		space: 71,
		create: 99,
		usage: 58,
		reb: 99,
	},
	{
		id: "mcbrimi01",
		name: "Miles McBride",
		team: "NYC",
		pos: "G",
		price: 6,
		mpg: 24.9,
		per: 12.6,
		vorp: 0.8,
		pts: 9.5,
		trb: 2.5,
		ast: 2.9,
		off: 90,
		def: 70,
		space: 92,
		create: 87,
		usage: 61,
		reb: 65,
	},
	{
		id: "alvarjo01",
		name: "Jose Alvarado",
		team: "NYC",
		pos: "PG",
		price: 4,
		mpg: 24.4,
		per: 13.4,
		vorp: 0.2,
		pts: 10.3,
		trb: 2.4,
		ast: 4.6,
		off: 84,
		def: 68,
		space: 80,
		create: 97,
		usage: 68,
		reb: 70,
	},
	{
		id: "clarkjo01",
		name: "Jordan Clarkson",
		team: "NYC",
		pos: "G",
		price: 4,
		mpg: 26,
		per: 14.5,
		vorp: 0.1,
		pts: 16.2,
		trb: 3.2,
		ast: 3.7,
		off: 88,
		def: 56,
		space: 80,
		create: 94,
		usage: 85,
		reb: 70,
	},
	{
		id: "sochaje01",
		name: "Jeremy Sochan",
		team: "NYC",
		pos: "PF",
		price: 2,
		mpg: 25.3,
		per: 15.9,
		vorp: 0.3,
		pts: 11.4,
		trb: 6.5,
		ast: 2.4,
		off: 77,
		def: 68,
		space: 55,
		create: 82,
		usage: 66,
		reb: 86,
	},
	{
		id: "drumman01",
		name: "Andre Drummond",
		team: "NYC",
		pos: "C",
		price: 2,
		mpg: 18.8,
		per: 16,
		vorp: -0.2,
		pts: 7.3,
		trb: 7.8,
		ast: 0.9,
		off: 69,
		def: 72,
		space: 52,
		create: 74,
		usage: 66,
		reb: 99,
	},
	{
		id: "gilgesh01",
		name: "Shai Gilgeous-Alexander",
		team: "OKC",
		pos: "G",
		price: 10,
		mpg: 34.2,
		per: 30.7,
		vorp: 8.9,
		pts: 32.7,
		trb: 5,
		ast: 6.4,
		off: 99,
		def: 85,
		space: 70,
		create: 99,
		usage: 99,
		reb: 76,
	},
	{
		id: "willija06",
		name: "Jalen Williams",
		team: "OKC",
		pos: "GF",
		price: 10,
		mpg: 32.4,
		per: 20.3,
		vorp: 3.4,
		pts: 21.6,
		trb: 5.3,
		ast: 5.1,
		off: 99,
		def: 78,
		space: 66,
		create: 99,
		usage: 84,
		reb: 80,
	},
	{
		id: "harteis01",
		name: "Isaiah Hartenstein",
		team: "OKC",
		pos: "FC",
		price: 8,
		mpg: 27.9,
		per: 18.9,
		vorp: 2.1,
		pts: 11.2,
		trb: 10.7,
		ast: 3.8,
		off: 85,
		def: 85,
		space: 42,
		create: 90,
		usage: 61,
		reb: 99,
	},
	{
		id: "holmgch01",
		name: "Chet Holmgren",
		team: "OKC",
		pos: "FC",
		price: 8,
		mpg: 27.4,
		per: 19.2,
		vorp: 1,
		pts: 15,
		trb: 8,
		ast: 2,
		off: 86,
		def: 83,
		space: 68,
		create: 85,
		usage: 72,
		reb: 96,
	},
	{
		id: "mccaija01",
		name: "Jared McCain",
		team: "OKC",
		pos: "G",
		price: 6,
		mpg: 25.7,
		per: 15.2,
		vorp: 0.3,
		pts: 15.3,
		trb: 2.4,
		ast: 2.6,
		off: 94,
		def: 59,
		space: 85,
		create: 87,
		usage: 78,
		reb: 68,
	},
	{
		id: "carusal01",
		name: "Alex Caruso",
		team: "OKC",
		pos: "G",
		price: 6,
		mpg: 19.3,
		per: 15.9,
		vorp: 1.6,
		pts: 7.1,
		trb: 2.9,
		ast: 2.5,
		off: 82,
		def: 90,
		space: 71,
		create: 84,
		usage: 58,
		reb: 71,
	},
	{
		id: "mitchaj01",
		name: "Ajay Mitchell",
		team: "OKC",
		pos: "SG",
		price: 4,
		mpg: 16.6,
		per: 12,
		vorp: 0.1,
		pts: 6.5,
		trb: 1.9,
		ast: 1.8,
		off: 78,
		def: 71,
		space: 62,
		create: 82,
		usage: 60,
		reb: 66,
	},
	{
		id: "wallaca01",
		name: "Cason Wallace",
		team: "OKC",
		pos: "SG",
		price: 4,
		mpg: 27.6,
		per: 12.3,
		vorp: 1.5,
		pts: 8.4,
		trb: 3.4,
		ast: 2.5,
		off: 79,
		def: 84,
		space: 75,
		create: 81,
		usage: 53,
		reb: 68,
	},
	{
		id: "dortlu01",
		name: "Luguentz Dort",
		team: "OKC",
		pos: "GF",
		price: 2,
		mpg: 29.2,
		per: 11.3,
		vorp: 1.2,
		pts: 10.1,
		trb: 4.1,
		ast: 1.6,
		off: 84,
		def: 75,
		space: 82,
		create: 76,
		usage: 54,
		reb: 75,
	},
	{
		id: "willike04",
		name: "Kenrich Williams",
		team: "OKC",
		pos: "F",
		price: 2,
		mpg: 16.4,
		per: 13.7,
		vorp: 0.7,
		pts: 6.3,
		trb: 3.5,
		ast: 1.4,
		off: 82,
		def: 73,
		space: 73,
		create: 78,
		usage: 58,
		reb: 77,
	},
	{
		id: "wagnefr01",
		name: "Franz Wagner",
		team: "ORL",
		pos: "SF",
		price: 10,
		mpg: 33.7,
		per: 20.1,
		vorp: 2.6,
		pts: 24.2,
		trb: 5.7,
		ast: 4.7,
		off: 99,
		def: 75,
		space: 72,
		create: 99,
		usage: 92,
		reb: 83,
	},
	{
		id: "vucevni01",
		name: "Nikola Vucevic",
		team: "ORL",
		pos: "C",
		price: 10,
		mpg: 31.2,
		per: 20.3,
		vorp: 2.7,
		pts: 18.5,
		trb: 10.1,
		ast: 3.5,
		off: 99,
		def: 72,
		space: 70,
		create: 92,
		usage: 73,
		reb: 99,
	},
	{
		id: "suggsja01",
		name: "Jalen Suggs",
		team: "ORL",
		pos: "G",
		price: 8,
		mpg: 28.6,
		per: 14.4,
		vorp: 0.6,
		pts: 16.2,
		trb: 4,
		ast: 3.7,
		off: 91,
		def: 81,
		space: 89,
		create: 99,
		usage: 84,
		reb: 79,
	},
	{
		id: "banchpa01",
		name: "Paolo Banchero",
		team: "ORL",
		pos: "PF",
		price: 8,
		mpg: 34.4,
		per: 20,
		vorp: 2.2,
		pts: 25.9,
		trb: 7.5,
		ast: 4.8,
		off: 99,
		def: 69,
		space: 69,
		create: 99,
		usage: 97,
		reb: 95,
	},
	{
		id: "banede01",
		name: "Desmond Bane",
		team: "ORL",
		pos: "SG",
		price: 6,
		mpg: 32,
		per: 17.9,
		vorp: 2.9,
		pts: 19.2,
		trb: 6.1,
		ast: 5.3,
		off: 99,
		def: 70,
		space: 86,
		create: 99,
		usage: 75,
		reb: 84,
	},
	{
		id: "blackan01",
		name: "Anthony Black",
		team: "ORL",
		pos: "PG",
		price: 6,
		mpg: 24.2,
		per: 11.6,
		vorp: 0,
		pts: 9.4,
		trb: 2.9,
		ast: 3.1,
		off: 74,
		def: 75,
		space: 66,
		create: 89,
		usage: 67,
		reb: 71,
	},
	{
		id: "dasiltr01",
		name: "Tristan Da Silva",
		team: "ORL",
		pos: "SF",
		price: 4,
		mpg: 22,
		per: 9.9,
		vorp: -0.3,
		pts: 7.2,
		trb: 3.3,
		ast: 1.5,
		off: 79,
		def: 66,
		space: 77,
		create: 76,
		usage: 58,
		reb: 72,
	},
	{
		id: "bitadgo01",
		name: "Goga Bitadze",
		team: "ORL",
		pos: "C",
		price: 4,
		mpg: 20.4,
		per: 19.2,
		vorp: 1.6,
		pts: 7.2,
		trb: 6.6,
		ast: 2,
		off: 75,
		def: 85,
		space: 48,
		create: 78,
		usage: 56,
		reb: 94,
	},
	{
		id: "carteje01",
		name: "Jevon Carter",
		team: "ORL",
		pos: "PG",
		price: 2,
		mpg: 8.9,
		per: 12.2,
		vorp: 0,
		pts: 4.3,
		trb: 1.1,
		ast: 1.1,
		off: 81,
		def: 62,
		space: 80,
		create: 78,
		usage: 70,
		reb: 57,
	},
	{
		id: "cartewe01",
		name: "Wendell Carter Jr.",
		team: "ORL",
		pos: "FC",
		price: 2,
		mpg: 25.9,
		per: 13.7,
		vorp: 0.3,
		pts: 9.1,
		trb: 7.2,
		ast: 2,
		off: 72,
		def: 74,
		space: 63,
		create: 79,
		usage: 59,
		reb: 94,
	},
	{
		id: "maxeyty01",
		name: "Tyrese Maxey",
		team: "PHI",
		pos: "G",
		price: 10,
		mpg: 37.7,
		per: 19.5,
		vorp: 2,
		pts: 26.3,
		trb: 3.3,
		ast: 6.1,
		off: 99,
		def: 66,
		space: 92,
		create: 99,
		usage: 89,
		reb: 69,
	},
	{
		id: "brownja02",
		name: "Jaylen Brown",
		team: "PHI",
		pos: "GF",
		price: 10,
		mpg: 34.3,
		per: 17.8,
		vorp: 1.1,
		pts: 22.2,
		trb: 5.8,
		ast: 4.5,
		off: 99,
		def: 70,
		space: 73,
		create: 99,
		usage: 87,
		reb: 83,
	},
	{
		id: "embiijo01",
		name: "Joel Embiid",
		team: "PHI",
		pos: "C",
		price: 8,
		mpg: 30.2,
		per: 23.4,
		vorp: 0.8,
		pts: 23.8,
		trb: 8.2,
		ast: 4.5,
		off: 99,
		def: 69,
		space: 63,
		create: 99,
		usage: 99,
		reb: 92,
	},
	{
		id: "edgecvj01",
		name: "VJ Edgecombe",
		team: "PHI",
		pos: "SG",
		price: 8,
		mpg: 35,
		per: 14,
		vorp: 1,
		pts: 16,
		trb: 5.6,
		ast: 4.2,
		off: 90,
		def: 70,
		space: 80,
		create: 93,
		usage: 68,
		reb: 81,
	},
	{
		id: "simonan01",
		name: "Anfernee Simons",
		team: "PHI",
		pos: "SG",
		price: 6,
		mpg: 32.7,
		per: 14.9,
		vorp: 1.1,
		pts: 19.3,
		trb: 2.7,
		ast: 4.8,
		off: 98,
		def: 57,
		space: 99,
		create: 98,
		usage: 78,
		reb: 66,
	},
	{
		id: "watfotr01",
		name: "Trendon Watford",
		team: "PHI",
		pos: "F",
		price: 6,
		mpg: 20.8,
		per: 13,
		vorp: -0.3,
		pts: 10.2,
		trb: 3.6,
		ast: 2.6,
		off: 75,
		def: 65,
		space: 57,
		create: 89,
		usage: 75,
		reb: 77,
	},
	{
		id: "loveca01",
		name: "Caleb Love",
		team: "PHI",
		pos: "SG",
		price: 4,
		mpg: 20.7,
		per: 10.7,
		vorp: -0.3,
		pts: 10.4,
		trb: 2.3,
		ast: 2.5,
		off: 80,
		def: 57,
		space: 73,
		create: 85,
		usage: 74,
		reb: 66,
	},
	{
		id: "edwarju01",
		name: "Justin Edwards",
		team: "PHI",
		pos: "SF",
		price: 4,
		mpg: 26.3,
		per: 11.3,
		vorp: -0.5,
		pts: 10.1,
		trb: 3.4,
		ast: 1.6,
		off: 78,
		def: 61,
		space: 77,
		create: 76,
		usage: 61,
		reb: 66,
	},
	{
		id: "wadede01",
		name: "Dean Wade",
		team: "PHI",
		pos: "PF",
		price: 2,
		mpg: 21.2,
		per: 10.1,
		vorp: 0.7,
		pts: 5.4,
		trb: 4.2,
		ast: 1.3,
		off: 79,
		def: 73,
		space: 77,
		create: 72,
		usage: 47,
		reb: 74,
	},
	{
		id: "martity01",
		name: "Tyrese Martin",
		team: "PHI",
		pos: "SG",
		price: 2,
		mpg: 21.9,
		per: 10.9,
		vorp: -0.2,
		pts: 8.7,
		trb: 3.7,
		ast: 2,
		off: 78,
		def: 60,
		space: 76,
		create: 79,
		usage: 65,
		reb: 75,
	},
	{
		id: "greenja05",
		name: "Jalen Green",
		team: "PHO",
		pos: "SG",
		price: 10,
		mpg: 32.9,
		per: 15.1,
		vorp: 1.7,
		pts: 21,
		trb: 4.6,
		ast: 3.4,
		off: 99,
		def: 66,
		space: 89,
		create: 96,
		usage: 84,
		reb: 79,
	},
	{
		id: "bookede01",
		name: "Devin Booker",
		team: "PHO",
		pos: "G",
		price: 10,
		mpg: 37.3,
		per: 19.3,
		vorp: 1.7,
		pts: 25.6,
		trb: 4.1,
		ast: 7.1,
		off: 99,
		def: 56,
		space: 75,
		create: 99,
		usage: 88,
		reb: 72,
	},
	{
		id: "bridgmi02",
		name: "Miles Bridges",
		team: "PHO",
		pos: "F",
		price: 8,
		mpg: 31.7,
		per: 17.7,
		vorp: 2,
		pts: 20.3,
		trb: 7.5,
		ast: 3.9,
		off: 97,
		def: 65,
		space: 81,
		create: 96,
		usage: 85,
		reb: 92,
	},
	{
		id: "bealbr01",
		name: "Bradley Beal",
		team: "PHO",
		pos: "SG",
		price: 8,
		mpg: 32.1,
		per: 15.2,
		vorp: 0.4,
		pts: 17,
		trb: 3.3,
		ast: 3.7,
		off: 94,
		def: 62,
		space: 73,
		create: 93,
		usage: 73,
		reb: 66,
	},
	{
		id: "brookdi01",
		name: "Dillon Brooks",
		team: "PHO",
		pos: "GF",
		price: 6,
		mpg: 31.8,
		per: 11,
		vorp: 0.4,
		pts: 14,
		trb: 3.7,
		ast: 1.7,
		off: 90,
		def: 68,
		space: 86,
		create: 80,
		usage: 63,
		reb: 67,
	},
	{
		id: "goodwjo01",
		name: "Jordan Goodwin",
		team: "PHO",
		pos: "G",
		price: 6,
		mpg: 18.7,
		per: 12.1,
		vorp: 0.2,
		pts: 5.6,
		trb: 3.9,
		ast: 1.4,
		off: 82,
		def: 76,
		space: 71,
		create: 80,
		usage: 55,
		reb: 80,
	},
	{
		id: "gilleco01",
		name: "Collin Gillespie",
		team: "PHO",
		pos: "PG",
		price: 4,
		mpg: 14,
		per: 16.8,
		vorp: 0.5,
		pts: 5.9,
		trb: 2.4,
		ast: 2.4,
		off: 97,
		def: 69,
		space: 84,
		create: 85,
		usage: 63,
		reb: 70,
	},
	{
		id: "willima07",
		name: "Mark Williams",
		team: "PHO",
		pos: "C",
		price: 4,
		mpg: 26.6,
		per: 23.9,
		vorp: 1.6,
		pts: 15.3,
		trb: 10.2,
		ast: 2.5,
		off: 91,
		def: 77,
		space: 35,
		create: 83,
		usage: 71,
		reb: 99,
	},
	{
		id: "dunnry01",
		name: "Ryan Dunn",
		team: "PHO",
		pos: "SF",
		price: 2,
		mpg: 19.1,
		per: 10.7,
		vorp: -0.7,
		pts: 6.9,
		trb: 3.6,
		ast: 0.8,
		off: 75,
		def: 67,
		space: 72,
		create: 72,
		usage: 61,
		reb: 75,
	},
	{
		id: "spencpa01",
		name: "Pat Spencer",
		team: "PHO",
		pos: "PG",
		price: 2,
		mpg: 6.4,
		per: 12.6,
		vorp: 0,
		pts: 2.5,
		trb: 1.2,
		ast: 1.2,
		off: 72,
		def: 73,
		space: 62,
		create: 82,
		usage: 71,
		reb: 67,
	},
	{
		id: "moranja01",
		name: "Ja Morant",
		team: "POR",
		pos: "PG",
		price: 10,
		mpg: 30.4,
		per: 19.3,
		vorp: 1.7,
		pts: 23.2,
		trb: 4.1,
		ast: 7.3,
		off: 99,
		def: 66,
		space: 68,
		create: 99,
		usage: 94,
		reb: 76,
	},
	{
		id: "lillada01",
		name: "Damian Lillard",
		team: "POR",
		pos: "PG",
		price: 10,
		mpg: 36.1,
		per: 21.3,
		vorp: 3.2,
		pts: 24.9,
		trb: 4.7,
		ast: 7.1,
		off: 99,
		def: 63,
		space: 99,
		create: 99,
		usage: 85,
		reb: 79,
	},
	{
		id: "avdijde01",
		name: "Deni Avdija",
		team: "POR",
		pos: "SF",
		price: 8,
		mpg: 30,
		per: 17.7,
		vorp: 2.2,
		pts: 16.9,
		trb: 7.3,
		ast: 3.9,
		off: 94,
		def: 71,
		space: 78,
		create: 98,
		usage: 75,
		reb: 92,
	},
	{
		id: "holidjr01",
		name: "Jrue Holiday",
		team: "POR",
		pos: "G",
		price: 8,
		mpg: 30.6,
		per: 13.5,
		vorp: 1.3,
		pts: 11.1,
		trb: 4.3,
		ast: 3.9,
		off: 89,
		def: 74,
		space: 82,
		create: 92,
		usage: 59,
		reb: 77,
	},
	{
		id: "sharpsh01",
		name: "Shaedon Sharpe",
		team: "POR",
		pos: "SG",
		price: 6,
		mpg: 31.3,
		per: 14.5,
		vorp: 0.4,
		pts: 18.5,
		trb: 4.5,
		ast: 2.8,
		off: 89,
		def: 63,
		space: 76,
		create: 88,
		usage: 79,
		reb: 78,
	},
	{
		id: "camarto01",
		name: "Toumani Camara",
		team: "POR",
		pos: "PF",
		price: 6,
		mpg: 32.7,
		per: 12.5,
		vorp: 1.2,
		pts: 11.3,
		trb: 5.8,
		ast: 2.2,
		off: 83,
		def: 75,
		space: 82,
		create: 79,
		usage: 56,
		reb: 79,
	},
	{
		id: "clingdo01",
		name: "Donovan Clingan",
		team: "POR",
		pos: "C",
		price: 4,
		mpg: 19.8,
		per: 17.4,
		vorp: 0.6,
		pts: 6.5,
		trb: 7.9,
		ast: 1.1,
		off: 75,
		def: 80,
		space: 61,
		create: 73,
		usage: 56,
		reb: 99,
	},
	{
		id: "hendesc01",
		name: "Scoot Henderson",
		team: "POR",
		pos: "PG",
		price: 4,
		mpg: 26.7,
		per: 12.5,
		vorp: -0.1,
		pts: 12.7,
		trb: 3,
		ast: 5.1,
		off: 79,
		def: 63,
		space: 74,
		create: 98,
		usage: 73,
		reb: 70,
	},
	{
		id: "krejcvi01",
		name: "Vit Krejci",
		team: "POR",
		pos: "G",
		price: 2,
		mpg: 20.2,
		per: 12.7,
		vorp: 0.8,
		pts: 7.2,
		trb: 2.7,
		ast: 2.6,
		off: 82,
		def: 68,
		space: 81,
		create: 79,
		usage: 53,
		reb: 65,
	},
	{
		id: "williro04",
		name: "Robert Williams",
		team: "POR",
		pos: "C",
		price: 2,
		mpg: 17.6,
		per: 18.9,
		vorp: 0.4,
		pts: 5.8,
		trb: 5.9,
		ast: 1.1,
		off: 73,
		def: 87,
		space: 46,
		create: 70,
		usage: 51,
		reb: 93,
	},
	{
		id: "wembavi01",
		name: "Victor Wembanyama",
		team: "SA",
		pos: "FC",
		price: 10,
		mpg: 33.2,
		per: 24.2,
		vorp: 3.3,
		pts: 24.3,
		trb: 11,
		ast: 3.7,
		off: 99,
		def: 93,
		space: 81,
		create: 99,
		usage: 90,
		reb: 99,
	},
	{
		id: "foxde01",
		name: "De'Aaron Fox",
		team: "SA",
		pos: "PG",
		price: 10,
		mpg: 37,
		per: 19,
		vorp: 1.3,
		pts: 25,
		trb: 5,
		ast: 6.1,
		off: 99,
		def: 66,
		space: 75,
		create: 99,
		usage: 88,
		reb: 77,
	},
	{
		id: "vassede01",
		name: "Devin Vassell",
		team: "SA",
		pos: "GF",
		price: 8,
		mpg: 31,
		per: 14.2,
		vorp: 0.4,
		pts: 16.3,
		trb: 4,
		ast: 2.9,
		off: 89,
		def: 67,
		space: 92,
		create: 87,
		usage: 73,
		reb: 71,
	},
	{
		id: "harrito02",
		name: "Tobias Harris",
		team: "SA",
		pos: "F",
		price: 8,
		mpg: 31.6,
		per: 13.9,
		vorp: 1.2,
		pts: 13.7,
		trb: 5.9,
		ast: 2.2,
		off: 86,
		def: 73,
		space: 72,
		create: 82,
		usage: 63,
		reb: 86,
	},
	{
		id: "harpedy01",
		name: "Dylan Harper",
		team: "SA",
		pos: "SG",
		price: 6,
		mpg: 22.6,
		per: 16.2,
		vorp: 1.3,
		pts: 11.8,
		trb: 3.4,
		ast: 3.9,
		off: 88,
		def: 71,
		space: 62,
		create: 96,
		usage: 72,
		reb: 73,
	},
	{
		id: "castlst01",
		name: "Stephon Castle",
		team: "SA",
		pos: "G",
		price: 6,
		mpg: 26.7,
		per: 13.7,
		vorp: -0.6,
		pts: 14.7,
		trb: 3.7,
		ast: 4.1,
		off: 81,
		def: 63,
		space: 63,
		create: 99,
		usage: 81,
		reb: 76,
	},
	{
		id: "johnske04",
		name: "Keldon Johnson",
		team: "SA",
		pos: "SF",
		price: 4,
		mpg: 23.9,
		per: 15.6,
		vorp: 0.2,
		pts: 12.7,
		trb: 4.8,
		ast: 1.6,
		off: 86,
		def: 62,
		space: 68,
		create: 81,
		usage: 71,
		reb: 84,
	},
	{
		id: "champju02",
		name: "Julian Champagnie",
		team: "SA",
		pos: "SF",
		price: 4,
		mpg: 23.6,
		per: 12.2,
		vorp: 0.4,
		pts: 9.9,
		trb: 3.9,
		ast: 1.4,
		off: 85,
		def: 65,
		space: 90,
		create: 76,
		usage: 62,
		reb: 76,
	},
	{
		id: "barneha02",
		name: "Harrison Barnes",
		team: "SA",
		pos: "F",
		price: 2,
		mpg: 27.2,
		per: 14.9,
		vorp: 1.2,
		pts: 12.3,
		trb: 3.8,
		ast: 1.7,
		off: 89,
		def: 58,
		space: 83,
		create: 79,
		usage: 59,
		reb: 72,
	},
	{
		id: "waterli01",
		name: "Lindy Waters III",
		team: "SA",
		pos: "SG",
		price: 2,
		mpg: 17.2,
		per: 8.4,
		vorp: -0.2,
		pts: 5.5,
		trb: 2.5,
		ast: 1.1,
		off: 72,
		def: 66,
		space: 81,
		create: 71,
		usage: 56,
		reb: 66,
	},
	{
		id: "sabondo01",
		name: "Domantas Sabonis",
		team: "SAC",
		pos: "FC",
		price: 10,
		mpg: 34.7,
		per: 22.9,
		vorp: 4.4,
		pts: 19.1,
		trb: 13.9,
		ast: 6,
		off: 99,
		def: 74,
		space: 59,
		create: 99,
		usage: 71,
		reb: 99,
	},
	{
		id: "derozde01",
		name: "DeMar DeRozan",
		team: "SAC",
		pos: "GF",
		price: 10,
		mpg: 35.9,
		per: 17.7,
		vorp: 1.3,
		pts: 22.2,
		trb: 3.9,
		ast: 4.4,
		off: 99,
		def: 61,
		space: 60,
		create: 99,
		usage: 79,
		reb: 68,
	},
	{
		id: "westbru01",
		name: "Russell Westbrook",
		team: "SAC",
		pos: "PG",
		price: 8,
		mpg: 27.9,
		per: 14.3,
		vorp: 0.5,
		pts: 13.3,
		trb: 4.9,
		ast: 6.1,
		off: 87,
		def: 72,
		space: 68,
		create: 99,
		usage: 76,
		reb: 86,
	},
	{
		id: "monkma01",
		name: "Malik Monk",
		team: "SAC",
		pos: "SG",
		price: 8,
		mpg: 31.6,
		per: 15,
		vorp: 0.6,
		pts: 17.2,
		trb: 3.8,
		ast: 5.6,
		off: 93,
		def: 62,
		space: 86,
		create: 99,
		usage: 78,
		reb: 72,
	},
	{
		id: "lavinza01",
		name: "Zach LaVine",
		team: "SAC",
		pos: "GF",
		price: 6,
		mpg: 34.1,
		per: 18.4,
		vorp: 1.3,
		pts: 24,
		trb: 4.8,
		ast: 4.5,
		off: 99,
		def: 59,
		space: 94,
		create: 97,
		usage: 82,
		reb: 75,
	},
	{
		id: "murrake02",
		name: "Keegan Murray",
		team: "SAC",
		pos: "F",
		price: 6,
		mpg: 34.3,
		per: 12,
		vorp: 0.2,
		pts: 12.4,
		trb: 6.7,
		ast: 1.4,
		off: 88,
		def: 66,
		space: 78,
		create: 75,
		usage: 57,
		reb: 84,
	},
	{
		id: "huntede01",
		name: "De'Andre Hunter",
		team: "SAC",
		pos: "SF",
		price: 4,
		mpg: 28.8,
		per: 15.8,
		vorp: 0.4,
		pts: 19,
		trb: 3.9,
		ast: 1.5,
		off: 92,
		def: 61,
		space: 87,
		create: 83,
		usage: 77,
		reb: 73,
	},
	{
		id: "raynama01",
		name: "Maxime Raynaud",
		team: "SAC",
		pos: "FC",
		price: 4,
		mpg: 26.5,
		per: 16,
		vorp: -0.2,
		pts: 12.5,
		trb: 7.5,
		ast: 1.4,
		off: 85,
		def: 62,
		space: 54,
		create: 75,
		usage: 64,
		reb: 92,
	},
	{
		id: "achiupr01",
		name: "Precious Achiuwa",
		team: "SAC",
		pos: "FC",
		price: 2,
		mpg: 20.5,
		per: 13.6,
		vorp: 0,
		pts: 6.6,
		trb: 5.6,
		ast: 1,
		off: 74,
		def: 73,
		space: 55,
		create: 73,
		usage: 57,
		reb: 88,
	},
	{
		id: "cliffni01",
		name: "Nique Clifford",
		team: "SAC",
		pos: "SG",
		price: 2,
		mpg: 25.1,
		per: 9,
		vorp: -1.4,
		pts: 8.6,
		trb: 3.8,
		ast: 2.4,
		off: 70,
		def: 63,
		space: 70,
		create: 82,
		usage: 62,
		reb: 74,
	},
	{
		id: "barnesc01",
		name: "Scottie Barnes",
		team: "TOR",
		pos: "GF",
		price: 10,
		mpg: 32.8,
		per: 17.8,
		vorp: 2.3,
		pts: 19.3,
		trb: 7.7,
		ast: 5.8,
		off: 99,
		def: 80,
		space: 66,
		create: 99,
		usage: 83,
		reb: 93,
	},
	{
		id: "leonaka01",
		name: "Kawhi Leonard",
		team: "TOR",
		pos: "SF",
		price: 10,
		mpg: 31.9,
		per: 20.5,
		vorp: 1.5,
		pts: 21.5,
		trb: 5.9,
		ast: 3.1,
		off: 99,
		def: 77,
		space: 75,
		create: 95,
		usage: 85,
		reb: 81,
	},
	{
		id: "barrerj01",
		name: "RJ Barrett",
		team: "TOR",
		pos: "GF",
		price: 8,
		mpg: 32.2,
		per: 16.5,
		vorp: 1.2,
		pts: 21.1,
		trb: 6.3,
		ast: 5.4,
		off: 96,
		def: 64,
		space: 72,
		create: 99,
		usage: 87,
		reb: 87,
	},
	{
		id: "quickim01",
		name: "Immanuel Quickley",
		team: "TOR",
		pos: "G",
		price: 8,
		mpg: 27.8,
		per: 17.5,
		vorp: 1,
		pts: 17.1,
		trb: 3.5,
		ast: 5.8,
		off: 99,
		def: 63,
		space: 91,
		create: 99,
		usage: 79,
		reb: 76,
	},
	{
		id: "poeltja01",
		name: "Jakob Poeltl",
		team: "TOR",
		pos: "C",
		price: 6,
		mpg: 29.6,
		per: 20,
		vorp: 1.7,
		pts: 14.5,
		trb: 9.6,
		ast: 2.8,
		off: 86,
		def: 79,
		space: 35,
		create: 84,
		usage: 65,
		reb: 99,
	},
	{
		id: "murraco01",
		name: "Collin Murray-Boyles",
		team: "TOR",
		pos: "PF",
		price: 6,
		mpg: 21.9,
		per: 16.4,
		vorp: 1,
		pts: 8.5,
		trb: 5,
		ast: 1.9,
		off: 83,
		def: 78,
		space: 56,
		create: 81,
		usage: 58,
		reb: 81,
	},
	{
		id: "anderky01",
		name: "Kyle Anderson",
		team: "TOR",
		pos: "F",
		price: 4,
		mpg: 15,
		per: 14.8,
		vorp: 0.6,
		pts: 5.3,
		trb: 3.1,
		ast: 2.3,
		off: 77,
		def: 80,
		space: 58,
		create: 83,
		usage: 59,
		reb: 70,
	},
	{
		id: "jackstr02",
		name: "Trayce Jackson-Davis",
		team: "TOR",
		pos: "FC",
		price: 4,
		mpg: 15.6,
		per: 18.5,
		vorp: 0.8,
		pts: 6.6,
		trb: 5,
		ast: 1.7,
		off: 78,
		def: 73,
		space: 35,
		create: 78,
		usage: 62,
		reb: 84,
	},
	{
		id: "sheadja01",
		name: "Jamal Shead",
		team: "TOR",
		pos: "PG",
		price: 2,
		mpg: 19.6,
		per: 9.9,
		vorp: -0.8,
		pts: 7.1,
		trb: 1.5,
		ast: 4.2,
		off: 71,
		def: 64,
		space: 67,
		create: 96,
		usage: 65,
		reb: 62,
	},
	{
		id: "lawsoaj01",
		name: "A.J. Lawson",
		team: "TOR",
		pos: "SG",
		price: 2,
		mpg: 18.7,
		per: 12.7,
		vorp: -0.1,
		pts: 9.1,
		trb: 3.3,
		ast: 1.2,
		off: 77,
		def: 62,
		space: 76,
		create: 78,
		usage: 68,
		reb: 71,
	},
	{
		id: "jacksja02",
		name: "Jaren Jackson Jr.",
		team: "UTA",
		pos: "FC",
		price: 10,
		mpg: 29.8,
		per: 19.6,
		vorp: 2.4,
		pts: 22.2,
		trb: 5.6,
		ast: 2,
		off: 99,
		def: 77,
		space: 73,
		create: 88,
		usage: 85,
		reb: 78,
	},
	{
		id: "markkla01",
		name: "Lauri Markkanen",
		team: "UTA",
		pos: "F",
		price: 10,
		mpg: 31.4,
		per: 15.6,
		vorp: 0.7,
		pts: 19,
		trb: 5.9,
		ast: 1.5,
		off: 99,
		def: 60,
		space: 93,
		create: 83,
		usage: 77,
		reb: 85,
	},
	{
		id: "georgke01",
		name: "Keyonte George",
		team: "UTA",
		pos: "G",
		price: 8,
		mpg: 31.5,
		per: 12.9,
		vorp: -0.3,
		pts: 16.8,
		trb: 3.8,
		ast: 5.6,
		off: 88,
		def: 53,
		space: 82,
		create: 99,
		usage: 77,
		reb: 73,
	},
	{
		id: "baileac01",
		name: "Ace Bailey",
		team: "UTA",
		pos: "SF",
		price: 8,
		mpg: 27.6,
		per: 11.6,
		vorp: -1.2,
		pts: 13.8,
		trb: 4.2,
		ast: 1.8,
		off: 82,
		def: 57,
		space: 78,
		create: 78,
		usage: 71,
		reb: 71,
	},
	{
		id: "sensabr01",
		name: "Brice Sensabaugh",
		team: "UTA",
		pos: "SF",
		price: 6,
		mpg: 20.2,
		per: 13.4,
		vorp: 0.3,
		pts: 10.9,
		trb: 3,
		ast: 1.5,
		off: 88,
		def: 58,
		space: 85,
		create: 78,
		usage: 71,
		reb: 70,
	},
	{
		id: "nurkiju01",
		name: "Jusuf Nurkic",
		team: "UTA",
		pos: "C",
		price: 6,
		mpg: 23.7,
		per: 12.6,
		vorp: -0.2,
		pts: 8.6,
		trb: 9.2,
		ast: 1.9,
		off: 67,
		def: 72,
		space: 59,
		create: 83,
		usage: 65,
		reb: 99,
	},
	{
		id: "loveke01",
		name: "Kevin Love",
		team: "UTA",
		pos: "FC",
		price: 4,
		mpg: 10.9,
		per: 16.2,
		vorp: 0.2,
		pts: 5.3,
		trb: 4.1,
		ast: 1,
		off: 80,
		def: 70,
		space: 72,
		create: 81,
		usage: 78,
		reb: 84,
	},
	{
		id: "filipky01",
		name: "Kyle Filipowski",
		team: "UTA",
		pos: "C",
		price: 4,
		mpg: 21.1,
		per: 14.9,
		vorp: 0.4,
		pts: 9.6,
		trb: 6.1,
		ast: 1.9,
		off: 79,
		def: 66,
		space: 69,
		create: 80,
		usage: 65,
		reb: 88,
	},
	{
		id: "mykhasv01",
		name: "Svi Mykhailiuk",
		team: "UTA",
		pos: "SF",
		price: 2,
		mpg: 20,
		per: 9.8,
		vorp: -0.3,
		pts: 8.8,
		trb: 2.4,
		ast: 2,
		off: 78,
		def: 56,
		space: 87,
		create: 81,
		usage: 69,
		reb: 66,
	},
	{
		id: "konchjo01",
		name: "John Konchar",
		team: "UTA",
		pos: "GF",
		price: 2,
		mpg: 12.1,
		per: 12.1,
		vorp: 0.5,
		pts: 2.4,
		trb: 3.3,
		ast: 0.9,
		off: 74,
		def: 78,
		space: 67,
		create: 70,
		usage: 42,
		reb: 79,
	},
	{
		id: "davisan02",
		name: "Anthony Davis",
		team: "WAS",
		pos: "FC",
		price: 10,
		mpg: 34.3,
		per: 27.1,
		vorp: 2.9,
		pts: 25.7,
		trb: 11.9,
		ast: 3.4,
		off: 99,
		def: 82,
		space: 58,
		create: 96,
		usage: 90,
		reb: 99,
	},
	{
		id: "youngtr01",
		name: "Trae Young",
		team: "WAS",
		pos: "PG",
		price: 10,
		mpg: 36,
		per: 18.3,
		vorp: 1.7,
		pts: 24.2,
		trb: 3.1,
		ast: 11.6,
		off: 99,
		def: 58,
		space: 85,
		create: 99,
		usage: 89,
		reb: 70,
	},
	{
		id: "aytonde01",
		name: "Deandre Ayton",
		team: "WAS",
		pos: "C",
		price: 8,
		mpg: 30.2,
		per: 17.7,
		vorp: 0.4,
		pts: 14.4,
		trb: 10.2,
		ast: 1.6,
		off: 91,
		def: 70,
		space: 51,
		create: 77,
		usage: 67,
		reb: 99,
	},
	{
		id: "sarral01",
		name: "Alex Sarr",
		team: "WAS",
		pos: "FC",
		price: 8,
		mpg: 27.1,
		per: 12.9,
		vorp: -0.6,
		pts: 13,
		trb: 6.5,
		ast: 2.4,
		off: 81,
		def: 67,
		space: 71,
		create: 87,
		usage: 76,
		reb: 85,
	},
	{
		id: "russeda01",
		name: "D'Angelo Russell",
		team: "WAS",
		pos: "PG",
		price: 6,
		mpg: 26.3,
		per: 13,
		vorp: 0.1,
		pts: 12.4,
		trb: 2.8,
		ast: 4.7,
		off: 86,
		def: 59,
		space: 78,
		create: 99,
		usage: 73,
		reb: 67,
	},
	{
		id: "champju01",
		name: "Justin Champagnie",
		team: "WAS",
		pos: "SF",
		price: 6,
		mpg: 21.6,
		per: 15.7,
		vorp: 0.5,
		pts: 8.8,
		trb: 5.7,
		ast: 1,
		off: 84,
		def: 70,
		space: 75,
		create: 73,
		usage: 59,
		reb: 85,
	},
	{
		id: "whitmca01",
		name: "Cam Whitmore",
		team: "WAS",
		pos: "SF",
		price: 4,
		mpg: 16.2,
		per: 15.5,
		vorp: 0.5,
		pts: 9.4,
		trb: 3,
		ast: 1,
		off: 88,
		def: 64,
		space: 66,
		create: 75,
		usage: 76,
		reb: 70,
	},
	{
		id: "johnstr03",
		name: "Tre Johnson",
		team: "WAS",
		pos: "SG",
		price: 4,
		mpg: 24.1,
		per: 10.6,
		vorp: -1.1,
		pts: 12.2,
		trb: 2.8,
		ast: 2,
		off: 82,
		def: 53,
		space: 85,
		create: 82,
		usage: 73,
		reb: 67,
	},
	{
		id: "coopesh01",
		name: "Sharife Cooper",
		team: "WAS",
		pos: "PG",
		price: 2,
		mpg: 17.1,
		per: 13.8,
		vorp: -0.3,
		pts: 8.1,
		trb: 2.1,
		ast: 3,
		off: 79,
		def: 54,
		space: 68,
		create: 91,
		usage: 68,
		reb: 66,
	},
	{
		id: "georgky01",
		name: "Kyshawn George",
		team: "WAS",
		pos: "GF",
		price: 2,
		mpg: 26.5,
		per: 8.8,
		vorp: -0.9,
		pts: 8.7,
		trb: 4.2,
		ast: 2.5,
		off: 71,
		def: 67,
		space: 79,
		create: 83,
		usage: 59,
		reb: 75,
	},
];
